export default {
  menu_search_placeholder: 'Rechercher un jeu',
  search_title: 'Recherche',
  search_placeholder: 'Rechercher un jeu',
  search_history: 'Historique de recherche',
  search_clear: 'Effacer',
  search_popular: 'Recherches populaires',
  search_recommended: 'Jeux recommandés',
  game_detail_title: 'Jeu',
  game_detail_rtp: 'RTP',
  game_detail_min_bet: 'MISE MINIMALE',
  game_detail_play: 'Jouer',
  game_detail_preview: 'Aperçu du jeu',
  game_detail_recommend: 'Jeux recommandés',
  qb_monery: '₦',
  account: 'Compte',
  Depósito: 'Dépôt',
  VIP: 'VIP',
  Saque: 'Retrait',
  Registro: 'Inscription',
  Entrar: 'Connexion',
  Apostas: 'Pari(s)',
  Agente: 'Agent',
  Promoção: 'Promotion',
  Reminder: 'Rappel',
  Início: 'Accueil',
  Bônus: 'Bonus',
  Enviar: 'Soumettre',
  Compartilhar: 'Partager',
  Meu: 'Mon',
  BRL: 'NGN',
  ALL: 'TOUS',
  noempt: 'Aucun enregistrement',
  // —— Refonte de marque i18n (élimine les fallback chinois) ——
  login_welcome: 'Ose le grand saut.',
  responsible_footer: '18+ · Jouez responsable',
  winner_empty: 'Aucun gagnant pour le moment',
  banner_load_failed: 'Échec du chargement des bannières. Affichage des dernières disponibles.',
  home_game_unavailable: 'La liste des jeux est temporairement indisponible.',
  layout_read_unavailable: 'Les donn\u00e9es de la page sont temporairement indisponibles. Veuillez r\u00e9essayer plus tard.',
  layout_entry_unavailable: "L'entr\u00e9e du jeu est temporairement indisponible. Veuillez r\u00e9essayer plus tard.",
  home_winning_unavailable: 'La liste des gagnants est temporairement indisponible.',
  region_select_required: 'Veuillez sélectionner une région valide et réessayer.',
  country_list_unavailable: 'La liste des pays/régions est indisponible. Veuillez réessayer plus tard.',
  feature_unavailable: 'Cette fonctionnalité est temporairement indisponible. Veuillez réessayer plus tard.',
  request_failed: 'Échec de la requête. Veuillez réessayer plus tard.',
  service_unavailable: 'Service temporairement indisponible. Veuillez réessayer plus tard.',
  profile_read_failed: 'Impossible de charger les données du profil. Les données déjà chargées ont été conservées.',
  settings_read_failed: 'Impossible de charger les données de sécurité du compte. Les paramètres déjà chargés ont été conservés.',
  wallet_balance_read_failed: 'Impossible de charger le solde. Le solde déjà chargé a été conservé.',
  login_required: 'Veuillez vous connecter pour continuer.',
  profile_refresh_failed: 'Impossible d’actualiser les données du profil. Veuillez réessayer plus tard.',
  logout_failed: 'Échec de la déconnexion. Veuillez réessayer plus tard.',
  save_failed: 'Échec de l’enregistrement. Veuillez réessayer plus tard.',
  Recarregar: 'Recharger',
  Receber: 'Recevoir',
  Recebido: 'Reçu',
  Regras: 'Règles',
  Obter: 'Obtenir',
  Sucesso: 'Succès',
  Cancelar: 'Annuler',
  Confirmar: 'Confirmer',
  Detalhes: 'Détails',
  TopNav_txt: 'Roue',
  TopNav_txt1: 'Pointage VIP',
  TopNav_txt2: '100% sur le premier dépôt',
  TopNav_txt3: 'Événement Coffre au trésor',
  TopNav_txt4: 'CEV',
  TopNav_txt5: 'CFA',
  index_txt: 'Bienvenue sur VUKAVI 🔥 Un saut te sépare de ta première victoire. Dépose et reçois ton bonus.',
  index_txt2: `Déposer maintenant`,
  home_txt: 'viens de retirer',
  home_txt2: 'Liste des gagnants',
  home_txt3: 'Plus de avantages vous attendent sur les canaux officiels',
  home_txt4: 'Partager sur les réseaux sociaux',
  home_txt5:
    'VUKAVI est une marque de jeux en ligne. Jouez de manière responsable. 18+',
  home_txt6: '@2024 VUKAVI Tous droits réservés',
  home_txt7: "Ne plus afficher aujourd'hui",
  home_txt8: 'Ne plus demander jamais',
  home_txt9: 'Déposer maintenant !',
  bonus_title: `Inviter des partenaires`,
  bonus_title2: `Premier dépôt`,
  bonus_title3: `Fonds d'assistance journaliers`,
  bonus_title4: `Première inscription`,
  bonus_title5: 'Forfait Rouge',
  bonus_title6: `Événement Coffre au trésor`,
  bonus_title7: `Bonus de mise à niveau VIP`,
  bonus_title8: `Remboursements d'équipe`,
  bonus_title9: `Bonus de pointage VIP`,
  bonus_txt: `<p>
            Lorsque vous disposez de suffisamment de temps et de ressources promotionnelles,
            nous vous invitons à contacter directement notre responsable ! Nous établirons un plan de salaire hebdomadaire détaillé ! Tant que vous avez la volonté, tant que vous avez le courage ! Tant que vous avez les ressources ! Nous vous invitons à nous rejoindre !
          </p>
          <p class="m-t-20">
            Conditions pour devenir agent : Influenceur connu sur les réseaux sociaux, passionné par la promotion. Aimez-vous la plateforme VUKAVI ? Avez-vous un grand nombre d'abonnés ou de groupes sociaux capables de convaincre un nombre significatif d'utilisateurs valides de rejoindre la plateforme VUKAVI ? Collaborez avec nous à long terme et participez à nos plans opérationnels et à nos activités promotionnelles.
          </p>
          <p class="m-t-20">
            Nous attendons avec impatience votre participation et votre financement : avantages VIP exclusifs et services de règlement de commissions exclusifs. Autres récompenses, telles que des dividendes de profit hebdomadaires. Salaire hebdomadaire élevé : 10 000 - 50 000 (sans limite supérieure).
          </p>`,
  bonus_txt2: `<p>
          Règles:<br />1. La participation au plan de salaire hebdomadaire du partenaire et
          aux activités de la plateforme peut se faire simultanément.<br />2.
          Le salaire hebdomadaire est versé ponctuellement chaque lundi.<br />3.Notre
          plan de salaire hebdomadaire n'a aucune restriction. Si le nombre d'abonnés actifs est inférieur ou égal à 10 000, vous pouvez contacter notre responsable pour établir un plan de salaire hebdomadaire VIP unique pour vous.<br />
          4. Le salaire hebdomadaire est déposé directement sur votre compte de la plateforme.
          <br />5. Nous rejetons les faux comptes. Tout faux compte détecté sera
          bloqué définitivement.
        </p>`,
  bonus_txt3: `<p class="font-color">
            Durée de l'événement du premier dépôt : Depuis maintenant jusqu'à une date finale qui sera annoncée ultérieurement.
          </p>
          <p class="m-t-20 m-b-10 f-t-16 f-w">Règles de l'événement :</p>
          <p class="font-color">
            Les utilisateurs peuvent demander des récompenses de bonus en fonction de leur premier dépôt, avec un bonus maximum de 100% du montant d'un dépôt unique. Pour retirer le bonus, une valeur de pari requise doit être atteinte, calculée comme |Bonus × n fois| du montant du dépôt.
          </p>
          <p class="m-t-20 f-t-16 f-w m-b-10">
            Niveaux de bonus du premier dépôt :
          </p>
          <div class="font-color" style="line-height: 20px">
            <p>
              Montant du dépôt | Pourcentage de bonus | Exigence de paris (Multiplicateur)
            </p>
            <p>3000-4999 | 177 | 1</p>
            <p>5000-9999 | 277 | 1</p>
            <p>10000-29999 | 777 | 1</p>
            <p>30000-49999 | 1777 | 1</p>
            <p>50000-99999 | 3777 | 1</p>
            <p>100000-299999 | 7777 | 1</p>
            <p>300000-499999 | 17777 | 1</p>
            <p>500000 | 57777 | 1</p>
            <p class="m-t-20 f-t-16 f-w m-b-10" >
              Niveaux de bonus du second dépôt :
            </p>
            <p>
              Montant du dépôt | Pourcentage de bonus | Exigence de paris (Multiplicateur)
            </p>
               <p>3000-4999 | 10% | 1</p>
            <p>5000-9999 | 10% | 1</p>
            <p>10000-29999 | 10% | 1</p>
            <p>30000-49999 | 10% | 1</p>
            <p>50000-99999 | 10% | 1</p>
            <p>100000-299999 | 10% | 1</p>
            <p>300000-499999 | 10% | 1</p>
            <p>500000 | 10% | 1</p>
                 <p class="m-t-20 f-t-16 f-w m-b-10" >
              Niveaux de bonus du troisième dépôt :
            </p>
            <p>
              Montant du dépôt | Pourcentage de bonus | Exigence de paris (Multiplicateur)
            </p>
              <p>3000-4999 | 10% | 1</p>
            <p>5000-9999 | 10% | 1</p>
            <p>10000-29999 | 10% | 1</p>
            <p>30000-49999 | 10% | 1</p>
            <p>50000-99999 | 10% | 1</p>
            <p>100000-299999 | 10% | 1</p>
            <p>300000-499999 | 10% | 1</p>
            <p>500000 | 10% | 1</p>
          </div>

          <p class="m-t-20 f-t-16 f-w m-b-10">Exemple :</p>
          <div class="font-color" style="line-height: 20px">
            <p>
              Un dépôt de 2 000  vous permet de gagner un bonus de 5% (100 ).
            </p>
            <p>
              Un dépôt de 2 000  vous permet de gagner un bonus de 5% (100 ).
              Cela signifie que vous devez parier (100  × 5) + 2 000  = 2 500 .
            </p>
            <p>
              Une fois que des paris de 2 500  ont été effectués, le bonus peut être retiré.
            </p>
            <p>Un pari de 20 000  débloquera le bonus.</p>
            <p class="m-t-20 f-t-16 f-w m-b-10">
              Notes :
            </p>
            <p>
              1. Cette promotion ne peut pas être annulée après avoir été appliquée avec succès. Pour supprimer toute restriction sur le compte, l'exigence de pari spécifique de la promotion doit être remplie.
            </p>
            <p>
              2. Si une arbitrage, une couverture ou tout comportement de gain déloyal est détecté, l'éligibilité à la promotion sera annulée et toutes les récompenses de bonus seront perdues.
            </p>
            <p>
              3. La valeur de pari valide ne comprend que les paris liquidés ayant résulté en une victoire ou une défaite. Tout événement annulé ou invalide ne comptera pas comme pari valide.
            </p>
            <p>
              4. Chaque joueur valide peut participer. Si toute violation est détectée, nous nous réservons le droit d'examiner et de récupérer indéfiniment tous les bonus et profits générés.
            </p>
            <p>
              5. Si vous retirez des fonds avant de remplir les exigences de pari, le bonus sera déduit par le système.
            </p>
          </div>`,
  bonus_txt4: `Recharger maintenant`,
  bonus_txt5: `Assurez-vous d'avoir un compte unique, un numéro de téléphone unique et un numéro de carte unique. Plusieurs inscriptions pour obtenir des bonus entraîneront le blocage permanent du compte.`,
  bonus_txt6: `Remboursement LSS CASHBACK`,
  bonus_txt7: `Remboursement en espèces (Cashback)`,
  bonus_txt8: `Taux de cashback VIP`,
  bonus_txt9: `Pertes`,
  bonus_txt10: `Montant du cashback`,
  bonus_txt11: `<p class="m-t-15 l-h-20" style="margin-left: 5px">
          1.Vous pouvez recevoir une opportunité de récompense de cashback chaque jour.
        </p>
        <p class="content-c5--cash">
          2.La valeur du pari est calculée de 00:00 hier jusqu'à 00:00 aujourd'hui.
        </p>
        <p class="content-c5--cash">
          3.Vous pouvez enregistrer la récompense entre 05:00 et 23:59 aujourd'hui.
        </p>
        <p class="content-c5--cash">
          4.La valeur du cashback est basée sur le montant réel de gain/perte, et vous
          pouvez recevoir le cashback correspondant tel que montré dans le tableau.
        </p>
        <p class="content-c5--cash">
          5.Si vous ne pariez pas pendant la période de remboursement ou si vos
          gains dépassent le montant parié, vous ne serez pas éligible au remboursement.
        </p>
        <p class="content-c5--cash">
          6.Le cashback maximum par personne, par fois, est de 1 000 000 .
        </p>
        <p class="content-c5--cash">
          7.Cependant, avant de pouvoir retirer la récompense, vous devez effectuer
          au moins 2 tours de paris avec la valeur reçue.
        </p>
        <p class="content-c5--cash">
          8.La décision finale sur toutes les questions est à la discrétion de VUKAVI.
        </p>`,
  bonus_txt12: `Détails de l'événement`,
  bonus_txt13: `Les nouveaux utilisateurs inscrits recevront un bonus aléatoire de 3500 
        gratuitement. Complétez les tâches assignées pour recevoir les récompenses correspondantes ;`,
  bonus_txt14: `<p class="f-t-16 f-w m-t-15" style="color:#ffffff">Détails de l'événement</p>
        <p class="m-t-15">
          1.After s'être inscrit en tant que membre, complétez les tâches assignées pour
          recevoir les récompenses correspondantes ;
        </p>
        <p class="m-t-10">2.Le bonus n'est disponible que pour les jeux de machines à sous PG</p>
        <p class="m-t-10">
          3.Chaque membre et chaque adresse IP ne peuvent participer qu'une seule fois. Si
          plusieurs comptes utilisent la même adresse IP, ils seront considérés comme
          la même personne et ne pourront plus participer ;
        </p>
        <p class="m-t-10">
          4.Les membres qui ont obtenu des profits grâce aux bonus de cet événement
          et ont demandé des retraits. Le niveau VIP doit atteindre le VIP2 pour effectuer
          des retraits complets.
        </p>
        <p class="m-t-10">
          5.VUKAVI se réserve le droit de modifier, d'interrompre ou d'annuler l'activité
          à tout moment.
        </p>`,
  bonus_txt15: `Connecter & Inscrire`,
  bonus_txt16: `Collecté avec succès.`,
  bonus_txt17: `HEURE DE LIBÉRATION`,
  bonus_txt18: `12:00-12:59`,
  bonus_txt19: `18:00-18:59`,
  bonus_txt20: `21:00-21:59`,
  bonus_txt21: `<p class="m-t-10">
          1.Vous recevrez un cashback chaque semaine.
        </p>
        <p class="m-t-10">
          2.La valeur du pari est calculée de 00:00 lundi jusqu'à 23:59 dimanche.
        </p>
        <p class="m-t-10">
          3.Vous pouvez échanger votre récompense de 00:00 du lundi suivant
          jusqu'à 23:59 du lundi suivant.
        </p>
        <p class="m-t-10">
          4.Le cashback est calculé en multipliant vos pertes réelles par le
          pourcentage de cashback.
        </p>
        <p class="m-t-10">
          5.Si vous ne pariez pas pendant la période de cashback ou si vos
          gains sont supérieurs à vos pertes de la semaine précédente, vous ne recevrez pas de cashback.
        </p>
        <p class="m-t-10">
          6.Le cashback maximum par personne par semaine est de 5 000 .
        </p>
        <p class="m-t-10">
          7.Cependant, avant de pouvoir retirer la récompense, vous devez effectuer
          au moins 3 tours de paris avec la valeur reçue.
        </p>
        <p class="m-t-10">
          8.La décision finale sur toutes les questions est à la discrétion de VUKAVI.
        </p>`,
  bonus_txt22: `Déposer et participer`,
  bonus_txt23: `Mon lien`,
  bonus_txt24: `Code d'invitation :`,
  bonus_txt25: `Sous-filiés valides`,
  bonus_txt26: `personnes`,
  bonus_txt26_single: `personne`,
  bonus_txt27: `Qu'est-ce qu'un numéro de promotion valide ?`,
  bonus_txt28: `(Répondre à toutes les exigences ci-dessous)`,
  bonus_txt29: `Total des dépôts du sous-filié`,
  bonus_txt30: `10000 ou plus`,
  bonus_txt31: `Total des paris du sous-filié`,
  bonus_txt32: `50000 ou plus`,
  bonus_txt33: `<p >
          1.Invitez des amis à ouvrir le Coffre au trésor. En complétant différentes
          quantités d'invitations, vous pouvez gagner les coffres correspondants, avec
          une valeur maximale de 20,000,000. Plus vous recrutez d'amis, plus la
          récompense est importante.
        </p>
        <p class="m-t-10">
          2.Cette activité est un cadeau supplémentaire de la plateforme et cumule également
          d'autres récompenses et commissions d'agent, c'est-à-dire que vous pouvez
          bénéficier de multiples récompenses simultanément. Les nouveaux sous-filiés directs inscrits
          à chaque cycle ne seront valides que s'ils répondent aux conditions de l'activité.
        </p>
        <p class="m-t-10">
          3.Les membres de niveaux inférieurs peuvent effectuer des paris valides sur la plateforme
          sans restriction.
        </p>
        <p class="m-t-10">
          4.Les récompenses doivent être échangées manuellement sur la plateforme ; les récompenses expirées
          seront distribuées automatiquement.
        </p>
        <p class="m-t-10">
          5.Le bonus (hors capital) accordé dans le cadre de cet événement nécessite 0
          paris valides pour être retiré. Les paris ne sont pas limités aux plateformes de jeu.
        </p>
        <p class="m-t-10">
          6.Cet événement est réservé aux opérations manuelles normales du titulaire du compte.
          L'utilisation de comptes, de logiciels de triche, de bots, de paris entre différents comptes,
          de manipulation mutuelle, d'arbitrage, d'utilisation d'API, de protocoles, d'exploitation de vulnérabilités,
          de contrôle de groupe ou d'autres moyens techniques est interdite. Sinon, les récompenses peuvent être
          annulées ou déduites, et le compte peut être gelé ou même mis sur liste noire.
        </p>
        <p class="m-t-10 m-b-20">
          7.Pour éviter des divergences dans l'interprétation du texte, la plateforme se réserve le droit
          d'interprétation finale de cet événement.
        </p>`,
  bonus_txt34: `Valeur de la récompense :`,
  bonus_txt35: `Taux de cashback VIP`,
  bonus_txt36: `Niveau`,
  bonus_txt37: `Récompense`,
  bonus_txt38: `<p class="content-c5-sign" style="margin-top: 15px">
        Pendant la période de l'événement, les utilisateurs peuvent recevoir des récompenses pour les mises à niveau de leur niveau VIP. Règles :
      </p>
      <p class="content-c5-sign">
         1. Les utilisateurs doivent compléter le rechargement pour le niveau VIP spécifié, et seulement après cela peuvent-ils réclamer le montant de récompense correspondant au niveau VIP. 
      </p>
      <p class="content-c5-sign">
        2. Cet événement est réservé uniquement aux titulaires de compte normaux. Il est interdit de participer par des méthodes telles que la location de comptes, l'utilisation de plugins, les paris depuis différents endroits, etc. Si de telles méthodes sont détectées, les récompenses seront annulées et le compte peut être gelé ou mis sur liste noire. Toute activité telle que le bourrage de commandes, l'arbitrage ou l'utilisation de moyens techniques comme des accords de contrôle de groupe entraînera la suspension du compte.  
      </p>
      `,
  bonus_txt39: `Remboursements d'équipe`,
  bonus_txt40: `<p class="m-t-10">
          1. Votre équipe recevra une récompense de remboursement chaque semaine.
        </p>
        <p class="m-t-10">
          2. Le montant total des paris de l'équipe est calculé de 00:00 lundi à 23:59 dimanche.
        </p>
        <p class="m-t-10">
          3. Vous pouvez échanger la récompense de remboursement de votre équipe de 00:00 du lundi suivant à 23:59 du lundi.
        </p>
        <p class="m-t-10">
          4. Le remboursement d'équipe est calculé en multipliant le montant total des pertes réelles de votre équipe par le pourcentage de remboursement.
        </p>
        <p class="m-t-10">
          5. Si votre équipe ne parie pas pendant la période de remboursement ou si le total des gains de votre équipe est supérieur au total des pertes de la semaine précédente, votre équipe ne recevra pas de remboursement.
        </p>
        <p class="m-t-10">
          6. Le remboursement maximum par équipe par semaine est soumis à la limite en vigueur de la plateforme.
        </p>
        <p class="m-t-10">
          7. Cependant, avant de pouvoir retirer la récompense de remboursement d'équipe, votre équipe doit effectuer au moins 3 tours de paris avec le montant de remboursement reçu.
        </p>
        <p class="m-t-10">
          8. La décision finale sur toutes les questions relatives aux remboursements d'équipe est à la discrétion de VUKAVI.
        </p>`,
  bonus_txt41: `Règles des récompenses journalières VIP`,
  bonus_txt42: `Après avoir atteint le niveau correspondant, si la valeur du pari valide est >=
        2 millions ou la valeur du dépôt >= 200 000 dans les 2 jours, vous pouvez échanger
        la récompense, qui sera versée en temps réel sur votre portefeuille de la plateforme.`,
  bonus_txt43: `Taux de cashback VIP`,
  mine_txt: `ID du compte :`,
  mine_txt2: `Valeur de croissance requise :`,
  mine_txt3: `Total des dépôts :`,
  mine_txt4: `Êtes-vous sûr de vouloir vous déconnecter ?`,
  mine_txt5: `Détails du portefeuille`,
  mine_txt6: `Historique des jeux`,
  mine_txt7: `Partager`,
  mine_txt8: `Nom du compte`,
  mine_txt9: `Modifier le mot de passe de connexion`,
  mine_txt10: `Modifier le mot de passe de retrait`,
  mine_txt11: `Compte`,
  mine_txt12: `Avatar`,
  mine_txt13: `Politique de confidentialité`,
  mine_txt14: `Se déconnecter`,
  recordOrder_title: 'Liste des commandes',
  recordOrder_txt: 'Émission à',
  recharge_success: 'Recharge réussie',
  order_reversed: 'Commande annulée',
  mc_read_all: 'Tout marquer comme lu',
  mc_delete_read: 'Supprimer les lus',
  mc_inbox: 'Boîte de réception',

  orderDetail_title: 'Détails de la commande',
  orderDetail_txt: 'Type de transaction',
  orderDetail_txt2: 'Méthode de remboursement',
  orderDetail_txt3: 'Date de remboursement',
  orderDetail_txt4: 'Numéro de commande',
  orderDetail_txt5: 'Numéro de compte bancaire',
  orderDetail_txt6: 'Note',
  authName_title: 'Authentification par nom réel',
  authName_txt: 'Nom réel',
  authName_txt2: `Assurez-vous que votre nom correspond au nom du compte bancaire
        pour garantir la sécurité.`,
  authName_txt3: 'Entrez votre nom',
  bankAdd_txt: 'Gérer le compte',
  setPassWord_title: 'Modifier le mot de passe de retrait',
  setPassWord_txt: `C'est votre premier retrait, vous devez d'abord définir le mot de passe de retrait`,
  setPassWord_txt2: `Définir votre mot de passe de retrait`,
  setPassWord_txt3: `Ancien mot de passe :`,
  setPassWord_txt4: `Nouveau mot de passe :`,
  setPassWord_txt5: `Remarque chaleureuse : Le mot de passe de retrait est très important. N'oubliez pas de le mémoriser et de le conserver en sécurité. Ne le dites à personne. En cas de perte, les actifs ne seront pas récupérés.`,
  setPassWord_txt6: `6 chiffres`,
  setPassWord_txt7: `Les mots de passe saisis deux fois sont inconsistants`,
  avatar_title: 'Sélectionner un avatar',
  bank_title: `Carte bancaire`,
  bank_txt: 'Supprimer cette carte bancaire ?',
  bank_txt2: `Mot de passe de retrait`,
  bank_empty: 'Aucune carte bancaire',
  bank_empty_desc: 'Ajoutez une carte bancaire pour les retraits',
  bank_add: 'Ajouter une carte',
  bank_pwd_ph: 'Entrez le mot de passe de retrait',
  billGame_title: `Enregistrement des jeux`,
  billGame_txt: `Jeu :`,
  billGame_txt2: `Pari :`,
  billGame_txt3: `Gain :`,
  billGame_txt4: `Aujourd'hui`,
  billGame_txt5: `Hier`,
  billGame_txt6: `Cette semaine`,
  billGame_txt7: `La semaine dernière`,
  billGame_txt8: `Ce mois`,
  billGame_txt9: `Le mois dernier`,
  billGame_txt10: `Tous`,
  gameHall_txt: `Complétez le dépôt initial pour accéder au jeu.`,
  gameHall_txt2: `En raison de la maintenance du jeu par le fabricant, veuillez revenir plus tard.`,
  gameHall_txt3: `La fonctionnalité du jeu a été désactivée. Veuillez contacter le support en ligne pour obtenir de l'aide.`,
  gameHall_txt4: `Solde insuffisant, veuillez recharger et continuer.`,
  gameHall_txt5: `Êtes-vous sûr de vouloir quitter le jeu actuel ?`,
  passwordLogin_title: `Modifier le mot de passe de connexion`,
  passwordLogin_txt: `Ancien mot de passe`,
  passwordLogin_txt2: `Nouveau mot de passe`,
  passwordLogin_txt3: `Mot de passe de connexion`,
  passwordLogin_txt4: `N'oubliez pas qu'une négligence dans la protection de votre mot de passe peut entraîner des pertes irréversibles. Gardez-le confidentiel et vous assurerez la sécurité continue de vos informations.`,
  passwordLogin_txt5: `Entrez l'ancien mot de passe.`,
  passwordLogin_txt6: `Entrez le mot de passe de connexion.`,
  passwordLogin_txt7: `Le nouveau mot de passe est identique à l'ancien.`,
  privacy_title: `Politique de confidentialité`,
  privacy_txt: `
    <p class="m-t-20 f-t-16 f-b font-color">
      Politique de confidentialité et protection des données personnelles
    </p>

    <p style="line-height: 20px; margin-top: 10px">1. Introduction :</p>
    <p class=" m-t-10" style="line-height: 20px">
      Chez VUKAVI, notre objectif est de fournir aux utilisateurs la meilleure expérience possible. Par conséquent, pour vous offrir des services de plus en plus personnalisés (notre utilisateur), nous avons besoin de comprendre vos habitudes de jeu et vos interactions.
      Cependant, la confidentialité et la sécurité de vos données personnelles sont toujours notre priorité absolue. C'est pourquoi nous souhaitons expliquer de manière transparente et détaillée comment nous collectons, stockons, partageons et utilisons vos données personnelles, ainsi que préciser les choix et options de contrôle dont vous disposez lorsque vous décidez de partager de telles données personnelles. C'est le but principal de cette Politique de confidentialité et de protection des données personnelles ("Politique").
    </p>

    <p class="m-t-10" style="line-height: 20px">2. À propos de cette Politique</p>

    <p class="m-t-10" style="line-height: 20px">
      Cette Politique décrit les détails clés concernant la relation entre les données personnelles des utilisateurs et VUKAVI. Cette Politique s'applique à tous les services de VUKAVI et à tout service connexe (collectivement désignés comme "Services de VUKAVI"). Les conditions régissant l'utilisation des Services de VUKAVI par les utilisateurs sont définies dans nos Conditions générales.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Nous pouvons développer de nouveaux services ou proposer des services supplémentaires de temps à autre. Si le lancement de ces nouveaux services ou services supplémentaires entraîne des modifications dans la manière dont nous collectons et traitons les données personnelles, nous fournirons des informations supplémentaires ainsi que des conditions ou politiques complémentaires. Sauf indication contraire spécifique, chaque fois que nous introduisons de nouveaux services ou services supplémentaires, ils seront régis par cette Politique.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Le but de cette Politique est :
    </p>

    <p class=" m-t-10" style="line-height: 20px">
      Assurer que les utilisateurs sont pleinement informés des données personnelles que nous collectons à leur sujet, pourquoi nous collectons et utilisons ces données, et avec qui nous les partageons ;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Expliquer comment nous utilisons les données personnelles que les utilisateurs nous partagent pour offrir une bonne expérience lors de l'utilisation des services de VUKAVI ;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Expliquer aux utilisateurs leurs droits et options respectifs concernant les données personnelles que nous collectons et traitons, et comment nous protégeons leur confidentialité.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Nous espérons que cette Politique vous aidera à comprendre notre engagement envers votre confidentialité. Si vous avez des préoccupations ou des questions, veuillez vous référer à la section 14, "Contact", ci-dessous, pour savoir comment nous contacter.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      D'autre part, si les utilisateurs ne sont pas d'accord avec le contenu de cette Politique, nous déclarons que les utilisateurs ont la liberté de décider d'utiliser et/ou de continuer à utiliser les services de VUKAVI.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Droits et préférences des utilisateurs : Offrir des choix et un contrôle :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Si vous ne le savez pas, les lois de l'UE et du Brésil, à savoir le "Règlement général sur la protection des données" (ou "RGPD") et la "Loi générale sur la protection des données du Brésil" (ou "LGPD"), confèrent certains droits aux individus concernant leurs données personnelles. Conformément aux dispositions légales applicables, sous réserve de toute restriction y figurant, les droits conférés aux individus sont les suivants :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Droit d'accès – Le droit d'être informé et de demander l'accès aux données personnelles que nous traitons à votre sujet ;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Droit de rectification – Le droit de demander que nous corrigions ou mettions à jour les données personnelles qui sont inexactes ou incomplètes ;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Droit à l'effacement – Le droit de demander que nous supprimions vos données personnelles de nos bases de données ;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Droit à la limitation – Le droit de demander que nous suspendions temporairement ou définitivement le traitement de tout ou partie de vos données personnelles ;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Droit d'opposition – Le droit de s'opposer au traitement de vos données personnelles pour des raisons liées à votre situation particulière à tout moment, le droit de s'opposer au traitement de vos données personnelles à des fins de marketing direct ;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Droit à la portabilité des données – Le droit de demander une copie de vos données personnelles au format électronique et de transmettre ces données à des services tiers ;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Droit de ne pas être soumis à des décisions automatisées – Le droit de ne pas être soumis à des décisions fondées uniquement sur un traitement automatisé, y compris le profilage, qui affectent significativement votre situation légale ou de manière similaire.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Pour permettre aux utilisateurs d'exercer facilement ces droits et d'enregistrer leurs préférences concernant l'utilisation que VUKAVI fait de leurs données personnelles, nous fournissons les options suivantes via les Paramètres de confidentialité sur la page "Mon profil" :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      1. Contrôler certaines catégories de données personnelles que nous traitons ;
    </p>

    <p class="m-t-10" style="line-height: 20px">
      2. Gérer les données personnelles que vous rendez publiques ;
    </p>

    <p class="m-t-10" style="line-height: 20px">3. Définir les préférences de partage.</p>

    <p class="m-t-10" style="line-height: 20px">
      Si nous envoyons des communications marketing électroniques sur la base de votre consentement ou d'un autre fondement légal applicable, les utilisateurs peuvent retirer leur consentement ou se désabonner à tout moment, sans frais. Pour ce faire, il suffit d'utiliser le lien de désabonnement dans l'e-mail lui-même pour vous retirer de la liste de diffusion.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Si vous avez des questions concernant votre confidentialité, vos droits ou la manière d'exercer ces droits, vous devez contacter notre Délégué à la protection des données via notre service client, et nous répondrons à l'utilisateur concerné dans un délai raisonnable après avoir vérifié son identité.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Si vous n'êtes pas satisfait de la manière dont nous traitons vos données personnelles, vous pouvez également déposer une plainte écrite auprès de l'autorité de protection des données de votre juridiction.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      4. Comment collectons-nous les données personnelles des utilisateurs ?
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Nous collectons les données personnelles des utilisateurs de la manière suivante :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Lorsque les utilisateurs s'inscrivent aux services de VUKAVI : Après l'inscription, nous collectons certaines données personnelles, telles que, mais sans s'y limiter : adresse e-mail, nom complet, sexe, pays/région, adresse IP, appareil utilisé et ses identifiants, afin qu'ils puissent utiliser les services de VUKAVI pertinents.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Par l'utilisation des services de VUKAVI : Lorsque les utilisateurs utilisent les services de VUKAVI, nous collectons des données personnelles sur leur utilisation des services de VUKAVI pertinents, telles que les jeux joués, l'historique de jeu, la liste des appareils utilisés pour accéder au service, le pseudonyme utilisé lors de l'accès depuis un seul appareil, les changements de position dans le classement, les changements des soldes de points virtuels pour chaque utilisateur, l'adresse IP utilisée pour l'accès, et autres informations nécessaires pour atteindre nos objectifs commerciaux. Par exemple, les utilisateurs peuvent également nous fournir occasionnellement des données personnelles supplémentaires ou nous autoriser à collecter d'autres données personnelles pour offrir plus de fonctionnalités ou de caractéristiques. Les données personnelles collectées nous permettent également d'atténuer les risques liés aux utilisateurs et aux services et/ou de prévenir la fraude.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Par l'intermédiaire de tiers – Nous pouvons également recevoir des données personnelles relatives aux utilisateurs et à leurs activités de la part de tiers (y compris les annonceurs et les partenaires avec lesquels nous travaillons) afin de pouvoir fournir les services de VUKAVI (voir la section 7 "Partage des données personnelles des utilisateurs" ci-dessous). Si les utilisateurs concernés autorisent le tiers ou MEGA SLOTS à partager de telles données, ou si VUKAVI a un intérêt légitime à utiliser ces données personnelles pour fournir les services de VUKAVI, nous utiliserons ces données personnelles.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Comme décrit ci-dessous, nous ne collecterons pas les photos des utilisateurs, la localisation géographique exacte des appareils mobiles, les données vocales ou les listes de contacts sans autorisation préalable de l'utilisateur. Vous pouvez toujours changer d'avis et retirer votre consentement.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      5. Quels types de données personnelles des utilisateurs collectons-nous ?
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Dans le tableau ci-dessous, nous résumons les catégories de données personnelles des utilisateurs que nous collectons et utilisons :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Catégorie de données personnelles, Description de la catégorie
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Informations d'inscription au compte, Il s'agit des données personnelles fournies par l'utilisateur ou collectées par nous afin que l'utilisateur puisse utiliser les services de VUKAVI.
      Cela inclut le nom de l'utilisateur, les documents d'identification, l'adresse e-mail, la date de naissance, le sexe et l'adresse physique. Les utilisateurs doivent fournir certaines données personnelles lors de la création d'un compte. Les utilisateurs peuvent également choisir de fournir des données personnelles supplémentaires pour personnaliser leur expérience.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Données d'utilisation. Fait référence aux données personnelles collectées lorsque les utilisateurs utilisent les services de VUKAVI, qui peuvent inclure : - Informations sur le type de plan de service de VUKAVI. - Informations sur les interactions des utilisateurs avec les services de VUKAVI, telles que les jeux joués, l'historique de jeu, la liste des appareils utilisés pour accéder au service, l'historique des pseudonymes utilisés pour accéder depuis un seul appareil, les changements de position dans le classement, les changements des soldes de points virtuels pour chaque utilisateur, et les interactions avec d'autres utilisateurs de VUKAVI. - Cela peut également inclure des informations sur l'utilisation d'applications tierces et toute publicité que vous recevez. - Contenu des utilisateurs qu'ils publient sur VUKAVI (tel que défini dans les Conditions générales), y compris les messages envoyés et/ou reçus via VUKAVI et les interactions avec le support client de VUKAVI. - Données techniques, qui peuvent inclure des informations sur l'URL, des données de cookies, l'adresse IP de l'utilisateur, les appareils utilisés pour accéder aux services de VUKAVI, les identifiants uniques de l'appareil, les attributs de l'appareil, et les types de connexions réseau (Wi-Fi, 3G, LTE, Bluetooth, etc.), le fournisseur de réseau, les performances du réseau et de l'appareil, le navigateur, la langue, les informations de gestion des droits numériques, le système d'exploitation, et la version de l'application VUKAVI.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Données personnelles collectées avec votre consentement Nous permettent de fournir des fonctionnalités ou caractéristiques supplémentaires :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Catégorie de données personnelles | Description de la catégorie
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Données mobiles facultatives <br />En plus des données mobiles que nous collectons pour fournir les services de VUKAVI (comme décrit ci-dessus), les utilisateurs peuvent choisir de nous autoriser à collecter des données personnelles supplémentaires à partir de leurs appareils mobiles afin que nous puissions fournir les fonctionnalités et caractéristiques suivantes qui améliorent votre expérience avec les services de VUKAVI.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Sans le consentement de l'utilisateur, nous ne collecterons aucune des données personnelles suivantes :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Photos de l'utilisateur – Si les utilisateurs nous accordent accès à leurs photos ou à leur appareil photo, nous ne collecterons que les images qu'ils choisissent spécifiquement de nous partager et les métadonnées associées à ces images, telles que le type de fichier et la taille de l'image.
      Nous ne téléchargerons ni n'importerons jamais toute la bibliothèque de photos ou le rouleau de l'appareil photo de l'utilisateur.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Localisation géographique exacte de l'appareil mobile de l'utilisateur – Si les utilisateurs autorisent l'accès à des emplacements spécifiques, nous pouvons utiliser le GPS ou le Bluetooth de l'utilisateur pour fournir les services de VUKAVI qui nécessitent des données de localisation exacte. Notez que cela n'inclut pas l'adresse IP de l'utilisateur. Nous utilisons l'adresse IP de l'utilisateur pour déterminer une localisation géographique non exacte, telle que le pays/région dans lequel il se trouve, dans le but de se conformer à nos Conditions générales.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Liste de contacts de l'utilisateur – Si les utilisateurs autorisent l'accès à leur liste de contacts, nous pouvons examiner la liste de contacts stockée sur leurs appareils pour les aider à trouver des amis qui utilisent MEGA SLOTS.
    </p>

    <p class="m-t-10" style="line-height: 20px">Informations de paiement</p>

    <p class="m-t-10" style="line-height: 20px">
      Si les utilisateurs s'inscrivent pour une période d'essai ou effectuent des achats via les services de VUKAVI (tel que défini dans les Conditions générales), nous pouvons collecter ces données personnelles. Les données réellement collectées peuvent varier selon la méthode de paiement, mais peuvent inclure ce qui suit :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Nom<br />
      Date de naissance<br />
      ID<br />
      Type de carte de débit ou de crédit, date d'expiration, et quelques chiffres du numéro de carte<br />
      Adresse physique<br />
      Numéro de téléphone<br />
      Historique des transactions de l'utilisateur<br />
      Si les utilisateurs choisissent de payer par facture, nous fournirons leurs données personnelles à notre processeur de paiement pour des vérifications de crédit et pour envoyer des factures à l'utilisateur.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Offres spéciales, concours et loteries
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Ces données personnelles sont utilisées pour permettre aux utilisateurs de s'inscrire et de participer à des offres spéciales. Les données personnelles collectées peuvent varier selon l'offre spéciale.
    </p>

    <p class="m-t-10" style="line-height: 20px">Données marketing</p>

    <p class="m-t-10" style="line-height: 20px">
      Ces données personnelles sont utilisées pour permettre à VUKAVI et à ses partenaires/prestataires de services d'envoyer des informations marketing aux utilisateurs :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Par e-mail<br />
      Lors de l'utilisation des services de VUKAVI<br />
      Directement de la part de tiers.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      6. À quelles fins utilisons-nous les données personnelles des utilisateurs ?
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Lorsque les utilisateurs utilisent ou interagissent avec les services de VUKAVI, nous utilisons diverses technologies pour traiter les données personnelles collectées pour diverses raisons.
      Dans le tableau ci-dessous, nous listons les raisons pour lesquelles nous traitons les données personnelles des utilisateurs, le fondement légal de nos actions, et les catégories de données personnelles (tel que défini dans la section 5 "Quels types de données personnelles collectons-nous sur les utilisateurs ?") utilisées aux fins suivantes :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Explication des raisons du traitement des données personnelles par VUKAVI
      ("Finalités du traitement")<br />
      Fondement légal de la finalité du traitement<br />
      Catégories de données personnelles utilisées pour la finalité du traitement
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Fournir, personnaliser et améliorer l'expérience de l'utilisateur avec le
      service de VUKAVI et d'autres services et produits fournis par VUKAVI,
      tels que l'offre de contenu et de recommandations personnalisés, basés sur la localisation ou spécifiques à un lieu,
      des fonctionnalités et des publicités (y compris des produits et services tiers)
      à l'intérieur ou à l'extérieur de VUKAVI.<br />
      Exécution du contrat<br />
      Données d'inscription au compte, données d'utilisation du service, et, le cas échéant,
      données mobiles facultatives
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Assurer l'intégrité des systèmes de classement fournis et réduire la fraude
      et la collusion liées aux utilisateurs dans l'environnement de divertissement de VUKAVI.
      Exécution du contrat, intérêts légitimes Données d'inscription au compte, données d'utilisation du service
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Comprendre comment les utilisateurs accèdent et utilisent le service de VUKAVI,
      dans le but d'assurer la fonctionnalité technique des services de VUKAVI,
      développer de nouveaux produits et services, et analyser l'utilisation des services de VUKAVI par les utilisateurs,
      y compris leurs interactions avec l'application, ainsi que la publicité,
      les produits et services liés à MEGA SLOTS ou fournis par ce dernier.<br />
      Exécution du contrat, intérêts légitimes Données d'inscription au compte, données d'utilisation du service
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Établir une communication avec les utilisateurs à des fins liées au service de VUKAVI.
      Exécution du contrat, intérêts légitimes Données d'inscription au compte, données d'utilisation du service
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Traiter les paiements des utilisateurs et prévenir ou identifier des activités frauduleuses,
      y compris des paiements frauduleux et une utilisation abusive des services de MEGA SLOTS.<br />
      Exécution du contrat, obligations légales, intérêts légitimes Données d'inscription au compte, données d'utilisation du service, informations de paiement
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Communiquer directement avec les utilisateurs ou par l'intermédiaire de nos partenaires pour les
      fins suivantes : Exécution du contrat, intérêts légitimes Données d'inscription au compte, données d'utilisation du service, informations de paiement
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Marketing<br />
      Sondages<br />
      Participation à des concours et offres spéciales
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Conformément à tout consentement que l'utilisateur peut avoir accordé à VUKAVI
      (par exemple, via les paramètres de confidentialité), par e-mail, notifications, ou autres messages.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Consentement<br />
      Intérêts légitimes
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Données de concours et de loterie<br />
      Données marketing
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Fournir aux utilisateurs des fonctionnalités, informations, publicités, ou contenu
      basé sur la localisation exacte de l'utilisateur.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Consentement<br />
      Données mobiles facultatives
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Les finalités pour lesquelles nous utilisons des informations anonymisées et agrégées
      incluent le test de nos systèmes informatiques, la recherche, l'analyse de données, la modélisation et la promotion marketing,
      l'amélioration des services de VUKAVI, et le développement de nouvelles fonctionnalités et caractéristiques pour les services de VUKAVI.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      7. Partage des données personnelles des utilisateurs:<br />
      Ci-dessous sont listées les catégories de destinataires qui peuvent recevoir des données personnelles collectées ou générées par l'utilisation des services de MEGA SLOTS (selon le cas) :
    </p>

    <p class="m-t-10" style="line-height: 20px">Informations publiques</p>

    <p class="m-t-10" style="line-height: 20px">
      Les données personnelles suivantes de l'utilisateur seront toujours disponibles publiquement sur les services de VUKAVI : pseudonyme de l'utilisateur, image de profil, informations sur les performances de jeu, et date de création du compte, ainsi que toute autre donnée personnelle vérifiable sur la page de profil de l'utilisateur.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Données personnelles partagées par l'utilisateur
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Les données personnelles suivantes ne seront partagées avec les catégories de destinataires listées ci-dessous que si :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      L'utilisateur sélectionne une fonctionnalité spécifique des services de VUKAVI qui nécessite le partage de données personnelles pour utiliser la fonctionnalité correctement. <br />L'utilisateur autorise explicitement le partage de données personnelles, par exemple en sélectionnant les paramètres appropriés dans les paramètres de confidentialité des services de VUKAVI.<br />
      Catégorie de contenu<br />
      Raison du partage
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Applications tierces utilisées pour se connecter à MEGA SLOTS<br />
      Lors de l'accès à votre compte VUKAVI depuis une application tierce (telle qu'une application de médias sociaux),
      VUKAVI peut partager des données pour lier le compte de l'utilisateur dans les deux enregistrements,
      c'est-à-dire le réseau VUKAVI et tout tiers.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Si l'utilisateur associe les identifiants de son compte MEGA SLOTS à une application tierce,
      une telle application tierce peut avoir accès à certaines données d'utilisation du service,
      contenu stocké, et activités. Avant de se connecter à une application tierce,
      l'utilisateur sera informé que ses données personnelles seront partagées avec et/ou accessibles par de telles applications tierces.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Communauté <br />Lorsqu'un utilisateur rejoint la communauté VUKAVI,
      il doit utiliser le même pseudonyme que son compte. De tels pseudonymes d'utilisateurs
      seront affichés publiquement à toute personne accédant à la zone de communauté VUKAVI,
      ainsi que toute question, commentaire, et autre contenu qu'ils choisissent de publier ou de rendre public
      via les paramètres de confidentialité des services de VUKAVI.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Pour des informations plus détaillées sur les informations publiques et le contenu que les utilisateurs partagent avec des tiers,
      veuillez vous référer à la section 3, "Droits et préférences des utilisateurs : Offrir des choix et un contrôle" dans cette politique et aux paramètres de confidentialité.
    </p>

    <p class="m-t-10" style="line-height: 20px">Informations que nous pouvons partager</p>

    <p class="m-t-10" style="line-height: 20px">
      Catégorie de contenu<br />
      Raison du partage
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Prestataires de services et autres parties Nous utilisons des prestataires de services techniques pour l'infrastructure nécessaire au fonctionnement des services de VUKAVI,
      en particulier ceux qui hébergent, stockent, gèrent et maintiennent l'application VUKAVI, son contenu, et les données que nous traitons.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Nous utilisons des prestataires de services techniques pour nous aider à communiquer avec les utilisateurs,
      comme décrit dans la section 6 de cette politique.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Nous utilisons également des partenaires de marketing et de publicité pour afficher un contenu plus personnalisé
      ou pour nous aider à comprendre comment les utilisateurs utilisent les services de VUKAVI et fournir de meilleurs services.
      Nous pouvons également partager des données personnelles avec certains partenaires de marketing et de publicité pour envoyer des informations promotionnelles sur VUKAVI aux utilisateurs.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      De plus, nous utilisons des partenaires de paiement ; cependant, dans ce cas, nous ne stockons ni ne partageons de données de carte de crédit ou d'autres méthodes de paiement,
      et toutes les données liées aux paiements saisies sur nos pages sont cryptées et envoyées à l'API de paiement pertinente.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Partenaires de VUKAVI<br />
      Si l'utilisateur accède aux services de VUKAVI par le biais d'une offre reçue d'un tiers (tel que son opérateur de réseau mobile),
      nous partagerons des données personnelles sur son utilisation des services de VUKAVI, telles que si et dans quelle mesure il a utilisé l'offre,
      s'il a activé son compte MEGA SLOTS, ou s'il utilise activement les services de VUKAVI.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Nous partageons également les données personnelles des utilisateurs de manière anonymisée avec des partenaires de marketing qui nous aident dans nos promotions
      et avec des annonceurs qui nous permettent d'offrir des services gratuits.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Conformité aux autorités légales et de protection des données <br />Lorsque nous croyons de bonne foi qu'il est nécessaire de se conformer à des obligations légales applicables
      ou de répondre à des processus juridiques valides (tels que des mandats de perquisition, des ordonnances judiciaires, ou des citations),
      nous partagerons les données personnelles des utilisateurs.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Si nous croyons sincèrement qu'il est nécessaire pour nos intérêts légitimes ou ceux de tiers,
      et pour la sécurité nationale, l'application de la loi, le litige, les enquêtes criminelles,
      la protection de la sécurité de toute personne, ou pour prévenir une mort imminente ou des blessures corporelles,
      nous pouvons également partager les données personnelles des utilisateurs,
      à condition que nous estimions que ces intérêts ne l'emportent pas sur la nécessité de protéger les données personnelles des utilisateurs
      et leurs droits et libertés fondamentaux.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Acheteurs d'entreprise<br />
      Lorsque nous vendons ou négocions la vente de notre entreprise à un acheteur ou un acheteur potentiel,
      nous partagerons les données personnelles des utilisateurs.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Dans ces cas, VUKAVI continuera à assurer la confidentialité des données personnelles des utilisateurs,
      et nous informerons les utilisateurs avant de transférer leurs données personnelles à l'acheteur
      ou avant de se conformer à une politique de confidentialité différente.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      8. Conservation et suppression des données : <br />Nous conserverons les données personnelles des utilisateurs aussi longtemps que nécessaire pour fournir les services de VUKAVI
      et pour des raisons commerciales légitimes et nécessaires, telles que le maintien des performances des services de VUKAVI,
      la prise de décisions commerciales basées sur les données, la conformité à nos obligations légales, et le règlement des litiges.
      Nous conserverons certaines données personnelles obtenues des utilisateurs tant qu'ils restent des utilisateurs des services de VUKAVI.
      Par exemple, nous conserverons l'historique d'utilisation et l'historique d'achats, le profil, la position dans le classement,
      les enregistrements de crédit, et autres informations du compte.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      À la demande de l'utilisateur, nous supprimerons ou anonymiserons ses données personnelles de sorte que l'utilisateur ne puisse pas être identifié,
      sauf si la loi permet ou exige la conservation de certaines données personnelles pendant le traitement, y compris dans les situations suivantes :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      S'il y a des problèmes en suspens dans le compte de l'utilisateur, tels que des crédits en attente ou des plaintes ou litiges non résolus,
      nous conserverons toutes les données personnelles nécessaires jusqu'à ce que le problème soit résolu.<br />Si nous devons conserver des données personnelles pour nous conformer à nos obligations légales, fiscales, d'audit et comptables,
      nous conserverons toutes les données personnelles nécessaires pendant la période requise par la loi applicable.<br />
      Chaque fois que nous estimons qu'il est nécessaire de maintenir nos intérêts commerciaux légitimes,
      tels que la prévention de la fraude ou l'assurance de la sécurité de nos utilisateurs.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      9. Transfert vers d'autres pays : VUKAVI partage certaines des données personnelles obtenues auprès d'utilisateurs du monde entier avec UNITED JOY LLP,
      dont le siège est à Londres, Royaume-Uni, pour mener les activités spécifiées dans cette politique.
    </p>
    <p class="m-t-10" style="line-height: 20px">
      VUKAVI peut également sous-traiter des services ou partager les données personnelles obtenues
      des utilisateurs avec des tiers situés dans des pays autres que le pays de résidence de l'utilisateur.
      Par conséquent, les données personnelles obtenues des utilisateurs peuvent être soumises à des lois
      sur la protection de la vie privée différentes de celles de leur pays de résidence.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Par exemple, les données personnelles collectées dans l'UE et en Suisse peuvent être
      transférées et traitées par des tiers situés hors de l'UE et de la Suisse. Dans ces cas,
      VUKAVI s'assurera que le transfert des données personnelles des utilisateurs est conforme
      aux lois applicables sur la protection de la vie privée et, en particulier, que des mesures
      contractuelles, techniques et organisationnelles appropriées sont mises en place, telles que
      les clauses contractuelles types approuvées par la Commission européenne.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Pour plus d'informations sur les mesures de sécurité que nous utilisons pour protéger les
      données personnelles des utilisateurs, veuillez vous référer à la section 11, « Garantir la
      sécurité des données personnelles des utilisateurs ».
    </p>

    <p class="m-t-10" style="line-height: 20px">
      10. URL :<br />
      Nous pouvons afficher des publicités de tiers et d'autres contenus, tels que des URL
      redirigeant vers des sites web de tiers. Nous n'avons aucun contrôle sur les pratiques de
      protection de la vie privée ou le contenu des tiers et ne sommes pas responsables de ceux-ci.
      Si les utilisateurs cliquent sur des publicités ou des URL de tiers, ils doivent savoir qu'ils
      quitteront les services de VUKAVI et que toute donnée personnelle qu'ils fournissent ne
      sera pas soumise à la présente politique. Les utilisateurs doivent lire les politiques de
      protection de la vie privée pertinentes pour comprendre comment leurs données personnelles
      seront collectées et traitées.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      11. Garantir la sécurité des données personnelles des utilisateurs : Nous nous engageons à
      protéger les données personnelles des utilisateurs.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Nous avons mis en place des mesures techniques et organisationnelles pour contribuer à garantir
      la sécurité des données personnelles obtenues des utilisateurs, telles que la création de
      pseudonymes, le chiffrement, et des politiques d'accès et de conservation afin d'empêcher
      tout accès non autorisé et toute conservation inutile de données personnelles dans nos
      systèmes. Cependant, les utilisateurs doivent savoir qu'aucun système n'est complètement
      sécurisé.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Les mots de passe peuvent protéger les comptes des utilisateurs, nous encourageons donc les
      utilisateurs à utiliser des mots de passe uniques et fiables, à limiter l'accès aux ordinateurs,
      navigateurs et autres appareils considérés comme sécurisés (digne de confiance), et à se
      déconnecter après avoir utilisé les services de VUKAVI.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      12. Enfants : <br />Enfants âgés de 13 à 18 ans<br />Nous recommandons aux mineurs âgés de
      plus de 13 ans d'obtenir le consentement parental avant d'envoyer toute information sur
      eux-mêmes sur Internet.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Les utilisateurs ne peuvent utiliser leur compte qu'à des fins de divertissement non commerciales.
      Les utilisateurs ne peuvent pas utiliser ce service à toute autre fin, telle que la collecte de
      jetons à partir de plusieurs comptes ou de toute autre manière. Les utilisateurs ne peuvent pas
      utiliser leur compte pour toute activité illégale.
      <br />Les utilisateurs ne peuvent pas envoyer de messages répétés (spam), de courriels non sollicités,
      de publicités ou de sollicitations en utilisant leur compte. <br />Les utilisateurs ne peuvent pas
      utiliser de langage grossier, discriminatoire ou malveillant de quelque manière que ce soit, y
      compris dans leur photo de profil.<br />Les utilisateurs ne peuvent pas utiliser leur compte pour
      tricher ou pirater le jeu. Perdre intentionnellement pour transférer des jetons est facilement
      traçable, et ce comportement entraînera la confiscation de leurs jetons et une interdiction.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      7. Sans l'autorisation écrite de VUKAVI, les utilisateurs ne peuvent pas sous-licencier,
      louer, vendre, donner, transférer ou de quelque autre manière céder leur compte ou des objets
      virtuels associés, en tout ou en partie, à toute personne.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      8. Les utilisateurs ne peuvent pas acheter ou acquérir de jetons, de bonus ou tout autre objet
      virtuel auprès de sources non autorisées (telles que des liens provenant de sources inconnues ou
      des personnes promettant des jetons gratuits, etc.).
    </p>

    <p class="m-t-10" style="line-height: 20px">
      9. Chaque réseau social permet aux utilisateurs d'utiliser le service avec un seul compte.
      De plus, les utilisateurs ne peuvent pas utiliser plusieurs comptes pour tenter d'accumuler
      des jetons gratuits. Ce comportement peut être facilement détecté et entraînera la suspension
      et/ou l'interdiction de tous leurs comptes.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      10. Les utilisateurs ne peuvent pas exploiter de scripts ou des processus manuels pour abuser
      de l'accumulation de jetons gratuits.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      11. Si un utilisateur a été exclu ou interdit d'utiliser le service, l'utilisateur ne peut
      pas utiliser aucun service ou créer de comptes ou utiliser tout compte.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      12. Si les utilisateurs n'approuvent pas les conditions d'utilisation, ils ne peuvent pas
      utiliser aucun jeu ou service de VUKAVI, et la permission de l'utilisateur d'utiliser le
      service sera immédiatement révoquée.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      13. Les utilisateurs n'ont pas le droit de :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Supprimer toute information ou contenu lié aux droits d'auteur dans le logiciel de VUKAVI
      et d'autres copies ; Effectuer un reverse engineering, désassembler, décompiler ou tenter de
      copier ou modifier le logiciel du jeu MEGA SLOTS pour quelque raison que ce soit ;
      Utiliser, copier, modifier, lier, republication, compiler, publier, transmettre, créer des
      sites miroirs, ou utiliser le jeu de VUKAVI à ces fins sans le consentement préalable de
      VUKAVI, ou développer des produits dérivés, œuvres ou services liés au logiciel.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      14. Modifications de la présente politique de confidentialité :
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Nous pouvons modifier la présente politique de temps à autre.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Lorsque nous apportons des modifications importantes à la présente politique, nous élaborerons
      des communications appropriées et visibles, telles que l'affichage de notifications proéminentes
      sur les services MEGA SLOTS ou l'envoi de courriels aux utilisateurs, selon les circonstances.
      Nous pouvons également communiquer avec les utilisateurs à l'avance.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      Par conséquent, les utilisateurs doivent lire attentivement toutes les communications.
    </p>

    <p class="m-t-10" style="line-height: 20px">15. Nous contacter :</p>

    <p class="m-t-10" style="line-height: 20px">
      Merci d'avoir lu notre politique de confidentialité. Si vous avez des questions sur la présente
      politique, veuillez contacter notre service client pour joindre notre Responsable de la
      protection des données. Nous répondrons dans un délai raisonnable après vérification de
      l'identité de l'utilisateur concerné.
    </p>

    <p class="m-t-10" style="line-height: 20px">
      VUKAVI est responsable du traitement des données personnelles des utilisateurs conformément
      à la présente politique.
    </p>
  `,
  profile_title: `Informations du compte`,
  vip_txt: `Valeur de croissance requise :`,
  vip_txt2: `Dépôts totaux :`,
  vip_txt3: `Liste des niveaux VIP`,
  vip_txt4: `Niveau`,
  vip_txt5: `Valeur du<br />dépôt`,
  vip_txt6: `Bonus de<br />mise à niveau`,
  vip_txt7: `Récompenses<br />quotidiennes`,
  vip_txt8: `Bonus<br />mensuel`,
  ResherContent_txt: `Afficher`,
  ResherContent_txt2: `sur`,
  ResherContent_txt3: `jeux`,
  ResherContent_txt4: `Voir plus`,
  ResherContent_txt5: `Plus rien à afficher`,
  BankInfo_txt: `Solde du compte :`,
  BankInfo_txt2: `Volume de paris requis pour atteindre`,
  BankInfo_txt_withdrawable: `Montant retirable :`,
  BankInfo_txt3: `Il reste encore à parier`,
  BankInfo_txt4: `Peut être retiré`,
  BankInfo_txt5: `Retrait standard`,
  BankInfo_txt6: `Ajouter un compte`,
  BankInfo_txt7: 'Tous',
  BankInfo_txt8: `Mot de passe de retrait`,
  BankInfo_txt9: `Veuillez saisir le montant du retrait.`,
  BankInfo_txt10: `Solde insuffisant pour le retrait`,
  BankInfo_txt11: `Plage de montant de retrait invalide`,
  BankInfo_txt12: `Gérer le compte`,
  BankInfo_txt13: `Ajouter`,
  BankInfo_txt14: `Il faut passer au niveau VIP3 pour en ajouter davantage.`,
  BankInfo_txt15: `Veuillez saisir votre CPF.`,
  BankInfo_txt16: `Veuillez saisir le compte Pix`,
  ActivityPopup_txt: `Avantages pour les nouveaux joueurs`,
  ActivityPopup_txt2: `Créer un compte`,
  ActivityPopup_txt3: `Bonus de 3 500`,
  ActivityPopup_txt4: `Bonus de 1 500`,
  ActivityPopup_txt5: `Aller`,
  ActivityPopup_txt6: `Ne plus afficher aujourd'hui`,
  ActivityPopup_txt7: `Ne plus demander jamais`,
  login_txt: `Saisir numéro portable`,
  login_txt2: `Créer votre compte`,
  login_txt3: `Connexion`,
  login_txt4: `Mot de passe`,
  login_txt5: `Force`,
  login_txt6: `Confirmez votre mot de passe`,
  login_txt7: `J'accepte`,
  login_txt8: `Conditions d'utilisation et Politique de confidentialité. `,
  login_txt9: `À propos de nous`,
  login_txt10: `Créer un compte`,
  login_txt11: `Connectez-vous maintenant`,
  login_txt12: `Autres méthodes de connexion`,
  login_txt13: `'Vérification réussie !'`,
  login_txt14: `'Vérification échouée, réessayez'`,
  login_txt15: `'Faites glisser le bloc pour compléter le puzzle'`,
  login_txt16: `Le nom d'utilisateur ne peut pas contenir moins de 6 caractères`,
  login_txt17: `Le mot de passe doit comporter entre 6 et 16 caractères`,
  login_txt18: `Le mot de passe répété ne correspond pas`,
  login_txt19: `Veuillez saisir le contenu`,
  login_txt20: `Le nom d'utilisateur ne peut pas contenir moins de 6 caractères`,
  login_txt21: `Le mot de passe doit comporter entre 6 et 16 caractères`,
  login_txt22: `J'accepte les conditions d'utilisation et la politique de confidentialité`,
  share_txt: `Mon lien :`,
  share_txt2: `Partager le lien via les applications sociales`,
  share_txt3: `Réseau d'agents`,
  share_txt4: `Performance totale 8 500 Commission totale`,
  share_txt5: `225`,
  share_txt6: `Performance 5 500 du sous-agent`,
  share_txt7: `Commission 3% Commission directe`,
  share_txt8: `165`,
  share_txt9: `Performance des autres 3 000`,
  share_txt10: `Différence de niveau 2% Autres commissions`,
  share_txt11: `60`,
  share_txt12: `<p class="f-t-16 f-w font-color2">Durée :</p>
          <p class="m-t-10 font-color">
            Dès maintenant jusqu'à une date finale annoncée ultérieurement.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Récompenses pour parrainage direct :
          </p>
          <p class="m-t-10 font-color">
            Pendant la durée de l'événement, pour chaque parrainage réussi d'un utilisateur valide, le parrain reçoit une récompense directe de 10, sans restriction, et la récompense peut être retirée immédiatement.
          </p>
          <p class="m-t-10 font-color">
            Définition d'utilisateur valide : L'utilisateur parrainé effectue un dépôt.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">Exemple :</p>
          <p class="m-t-10 font-color">
            a. L'utilisateur A invite B1, B2 et B3 ; A recevra une récompense de 10 × 3 = 30.
          </p>
          <p class="m-t-10 font-color">
            b. B1 invite C1 et C2 ; B1 recevra une récompense de 10 × 2 = 20.
          </p>
          <p class="m-t-10 font-color">
            c. B3 invite C3 ; B3 recevra une récompense de 10 × 1 = 10.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Bonus supplémentaire de commission sur les paris :
          </p>
          <p class="m-t-10 font-color">
            Le parrain peut également recevoir un bonus supplémentaire en fonction de la valeur des paris effectifs des utilisateurs parrainés.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">Taux de commission :</p>
          <p class="m-t-10 font-color">
            Si la valeur des paris effectifs est comprise entre 0 et 100, le taux de commission sera de 1 % (c'est-à-dire une récompense de 1 réel pour chaque 100 pariés).
          </p>
          <p class="font-color">
            Si la valeur des paris effectifs dépasse 100, le taux de commission sera de 3 % (c'est-à-dire une récompense de 3 pour chaque 100 pariés).
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">Hypothèses :</p>
          <p class="m-t-10 font-color">
            La valeur des paris effectifs pour B1 est de 50,
          </p>
          <p class="font-color">
            La valeur des paris effectifs pour B2 est de 300,
          </p>
          <p class="font-color">
            La valeur des paris effectifs pour B3 est de 20,
          </p>
          <p class="font-color">
            La valeur des paris effectifs pour C1 est de 10,
          </p>
          <p class="font-color">
            La valeur des paris effectifs pour C2 est de 20,
          </p>
          <p class="font-color">
            La valeur des paris effectifs pour C3 est de 200.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Le calcul de la commission se fait comme suit :
          </p>
          <p class="m-t-10 font-color">
            Commission pour B1 (contributions directes de C1 et C2) = (10 + 20) × 1 % = 0,3 réel.
          </p>
          <p class="font-color">
            Commission pour B2 (pas de subordonnés) = (0 + 0) × 1 % = 0 réel.
          </p>
          <p class="font-color">
            Commission pour B3 (contribution directe de C3) = 200 × 3 % = 6.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Commission pour A (des subordonnés directs B1, B2, B3, et des autres subordonnés C1, C2, C3) :
          </p>
          <p class="m-t-10 font-color">
            (1) Commission directe pour A (contributions directes de B1, B2 et B3) = (50 + 300 + 20) × 3 % = 11,1.
          </p>
          <p class="font-color">
            (2) Autre commission pour A (contributions de C1 et C2) = (10 + 20) × 2 % = 0,6 réel.
          </p>
          <p class="font-color">
            (3) Commission totale pour A (directe + autres) = 11,1 + 0,6 = 11,7.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">
            Description de la structure de l'équipe :
          </p>
          <p class="m-t-10 font-color">
            (1) Équipe directe désigne les subordonnés recrutés directement par A, c'est-à-dire l'équipe ayant une relation directe avec A.
          </p>
          <p class="font-color">
            (2) Autres équipes : désigne les subordonnés recrutés par les subordonnés de A, c'est-à-dire des équipes n'ayant pas de relation directe avec A (tels que des subordonnés de subordonnés, des subordonnés de subordonnés de subordonnés, etc.).
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(3) Description de A :</p>
          <p class="m-t-10 font-color">
            La performance directe de A est de 370, l'autre performance est de 30 (principalement grâce à la forte performance de C3), la performance totale est de 400, et le taux de commission correspondant est de 370*3%+30*2% = 11,7.
          </p>
          <p class="font-color">
            Puisque la performance totale de B1 est de 30, elle ne donne lieu qu'à un taux de commission de 1 %, éliminant la performance directe de A de 370, et elle donne lieu à un taux de commission de 3 %. Le reste n'est que de 30, qui provient de B1. Par conséquent, il y a une différence de niveau de 2 % entre A et B1.
          </p>
          <p class="font-color">
            Cette différence est attribuée à A par C1 et C2, c'est-à-dire : (10 + 20) × 2 % = 0,6 réel.
          </p>
          <p class="font-color">
            Il n'y a pas de différence de niveau entre A et B3, donc C3 ne contribue pas à la commission de A.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(4) Description de B1 :</p>
          <p class="m-t-10 font-color">
            B1 a des subordonnés C1 et C2, avec une performance directe de 30 et un taux de commission correspondant de 1 %.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(5) Description de B2 :</p>
          <p class="m-t-10 font-color">
            B2 ne peut pas recruter de subordonnés et n'a donc pas de revenu.
          </p>
          <p class="m-t-10 f-t-16 f-w font-color">(6) Description de B3 :</p>
          <p class="m-t-10 font-color">
            Bien que B3 ait rejoint plus tard et soit un subordonné de A, son subordonné C3 a eu une forte performance, avec des ventes directes de 200 RMB, permettant à B3 de bénéficier directement d'un taux de commission élevé de 3 %.
          </p>`,
  share_txt13: `Règles de règlement de la plateforme VUKAVI`,
  share_txt14: `Les remises sur parrainage et paris sont émises en temps réel. Cliquez sur 'Parrainages quotidiens' pour voir les détails des commissions.`,
  share_txt15: `Déclaration spéciale :`,
  share_txt16: `Pour assurer l'équité sur la plateforme, des politiques anti-triche sont appliquées. Les utilisateurs qui trichent seront interdits définitivement, les fonds obtenus illégalement seront gelés et une responsabilité légale sera engagée.`,
  share_txt17: `Synthèse des données`,
  share_txt18: `Subordonnés`,
  share_txt19: `directs`,
  share_txt20: `Nombre de dépôts`,
  share_txt21: `pour la première fois`,
  share_txt22: `La valeur du `,
  share_txt23: `premier dépôt`,
  share_txt24: `Total des demandes de`,
  share_txt25: `subordonnés directs`,
  share_txt26: `Total des paris valides`,
  share_txt27: `paris valides des subordonnés directs`,
  share_txt28: `<p>Nouveaux<br/>subordonnés</p>`,
  share_txt29: `<p>Valeur du premier <br/>dépôt</p>`,
  share_txt30: `<p>Nombre de <br/>joueurs ayant effectué<br/>leur premier dépôt</p>`,
  share_txt31: `<p>Valeur du dépôt</p>`,
  share_txt32: `<p>Nombre de <br/>dépôts</p>`,
  share_txt33: `<p>Paris valides</p>`,
  share_txt34: `Montant du dépôt : `,
  share_txt35: `Statut : `,
  share_txt36: `Ses subordonnés : `,
  share_txt37: `Paris valides : `,
  share_txt38: `Date de connexion : `,
  LuckyRoulette_txt: `Gagner`,
  LuckyRoulette_txt2: `Réclamer`,
  LuckyRoulette_txt3: `Réinitialiser les dépôts`,
  LuckyRoulette_txt4: `Gagner ≥ 100 pour récupérer`,
  LuckyRoulette_txt5: `nombre de fois nul`,
  LuckyRoulette_txt6: `restant`,
  LuckyRoulette_txt7: `Promouvoir 10 subordonnés pour obtenir 1 chance de nul`,
  LuckyRoulette_txt8: `Partager`,
  LuckyRoulette_txt9: `La connexion réussie du subordonné promu est considérée
                  valide, actuellement`,
  LuckyRoulette_txt10: `personnes sont valides`,
  LuckyRoulette_txt11: `
                      <p class="m-t-10">
                        1. Pendant la durée de l'événement, chaque membre peut
                        obtenir 1 chance de tirage au sort sur carrousel, et il peut
                        gagner jusqu'à 15 000 en bonus.
                      </p>
                      <p class="m-t-10">
                        2. Après avoir complété la tâche correspondante, vous pouvez
                        obtenir 1 chance de tirage au sort. Après que le nombre de
                        chances de tirage au sort ait été utilisé, vous pouvez
                        continuer à compléter la tâche et obtenir 1 chance de tirage
                        au sort ;
                      </p>
                      <p class="m-t-10">
                        3. Réinitialisation des récompenses quotidiennement,
                        complétez les missions pour réclamer ;
                      </p>
                      <p class="m-t-10">
                        4. Le gagnant des récompenses ne peut les réclamer manuellement
                        que sur les plateformes NPC Android_H5, iOS_H5, Android_app,
                        iOS_app ;
                      </p>
                      <p class="m-t-10">
                        5. Après 1 jour ATT et la fin de chaque cycle, les
                        récompenses reçues expirent et sont annulées directement ;
                      </p>
                      <p class="m-t-10">
                        6. Le bonus (hors capital) accordé dans le cadre de cet événement
                        nécessite 1 fois de paris valides pour être retiré. Le pari
                        n'est pas limité aux plateformes de jeu ;
                      </p>
                      <p class="m-t-10">
                        7. Cet événement est réservé aux opérations manuelles normales
                        du propriétaire du compte, et l'utilisation de logiciels de
                        triche, de bots, de paris entre différents comptes, de
                        manipulation mutuelle, d'arbitrage, d'APIs, de protocoles,
                        d'exploitation de vulnérabilités, de contrôle de groupe ou
                        d'autres moyens techniques est interdite, sinon les récompenses
                        peuvent être annulées ou déduites, ou les comptes peuvent être
                        gelés ou même ajoutés à la liste noire ;
                      </p>
                      <p class="m-t-10">
                        8. Pour éviter toute divergence dans la compréhension du texte,
                        la plateforme se réserve le droit de l'interprétation finale
                        de cet événement.
                      </p>`,
  LuckyRoulette_txt12: `Félicitations, vous avez gagné`,
  LuckyRoulette_txt13: `, qui peut être retiré pour seulement`,
  LuckyRoulette_txt14: `. Invitez`,
  LuckyRoulette_txt15: `amis à compléter l'inscription pour vous aider, et vous pouvez le réclamer lorsque vous dépenserez`,
  RechargeCont_txt: `Historique des dépôts`,
  RechargeCont_txt2: `Dépôt en ligne`,
  RechargeCont_txt3: `Les membres ne peuvent recevoir les bonus correspondants qu'après avoir déposé le montant recommandé. Le bonus supplémentaire et le bonus de dépôt peuvent être cumulés et offerts`,
  RechargeCont_txt4: `Le bonus peut être échangé après 1 facturation`,
  RechargeCont_txt5: `Détails de l'événement de bonus`,
  RechargeCont_txt6: `Premier dépôt, la valeur minimale pour le cadeau est de`,
  RechargeCont_txt7: `Les dépôts peuvent obtenir jusqu'à 10 % de bonus.`,
  RechargeCont_txt8: `Plage de valeur de dépôt incorrecte.`,
  common_txt: `Niveau actuel`,
  common_txt2: `Critères de promotion`,
  common_txt3: `Dépôt requis :`,
  common_txt4: `Liste des niveaux VIP`,
  common_txt5: `Détails VIP`,
  common_txt6: `En cours`,
  common_txt7: `numéro de téléphone`,
  common_txt8: `mot de passe`,
  common_txt9: `confirmer le mot de passe`,
  common_txt10: `Trésor`,
  common_txt11: `Offres`,
  common_txt12: `Remise`,
  common_txt13: `Collection`,
  common_txt14: `Super`,
  common_txt15: `Échanger`,
  common_txt16: `Roulette`,
  common_txt17: `Agent`,
  common_txt18: `Niveau`,
  common_txt19: `Mystérieux`,
  common_txt20: `Bonus`,
  common_txt21: `Centre de service client`,
  common_txt22: `Contacter`,
  common_txt23: `Support`,
  common_txt24: `<p class="m-b-5 f-t-15">Cher Utilisateur</p>
      <div>
        1. Les membres de niveau VIP1 ou supérieur peuvent retirer l'intégralité du solde de
        leur compte en une seule fois.<br />
        <p class="m-t-10">
          2. Il n'y a pas de limite au nombre de retraits par jour, et
          VUKAVI prend en charge les retraits en ligne 24h/24.
        </p>
        <p class="m-t-10">
          3. Le montant minimum pour un retrait unique est de 1 000.
          Aucune demande de retrait ne peut être initiée pour des montants inférieurs à ce seuil.
        </p>
        <p class="m-t-10">
          4. Chaque utilisateur ne peut initier qu'une seule demande de retrait à la fois. Une nouvelle
          demande de retrait ne peut être initiée qu'après le traitement de la précédente.
        </p>
        <p class="m-t-10">
          5. Habituellement, votre retrait sera crédité sur votre compte bancaire dans les
          1 minute. Si vous ne recevez pas le montant du retrait depuis longtemps,
          veuillez contacter le service client pour obtenir de l'aide.
        </p></div>
        `,
  common_txt25: `VUKAVI est une marque de jeux en ligne. Jouez de manière responsable. 18+`,
  common_txt26: `Commission`,
  common_txt27: `Comment inviter`,
  common_txt28: `Mes données`,
  common_txt29: `Détails des subordonnés`,
  common_txt30: `
        <div>
          <p class="m-t-10">
            1. Le bonus de recharge peut augmenter votre capital de jeu. Bien
            sûr, vous avez le droit de choisir de renoncer au bonus et de continuer
            à recharger.
          </p>
          <p class="m-t-10">
            2. Le bonus de recharge nécessite 1 enregistrement de pari de jeu valide
            avant qu'une demande de retrait ne puisse être initiée.
          </p>
          <p class="m-t-10">
            3. Après l'achèvement du paiement, le montant payé sera affiché dans le
            portefeuille de jeu. Si vous ne recevez pas le montant de recharge à temps,
            veuillez contacter le service client en ligne pour obtenir de l'aide.
          </p>
        </div> `,
  common_txt31: `Détails du score de crédit`,
  common_txt32: `Règles du CP`,
  common_txt33: ` Score de crédit initial : Votre compte commence avec un score de crédit de 100 points.
        Lorsque vous modifiez des informations sensibles (telles que votre nom réel,
        votre mot de passe de retrait ou votre compte bancaire) ou que vous tentez
        répétitivement des retraits incorrects, le système déduira des points correspondants
        pour protéger la sécurité de votre compte. Restrictions sur les retraits : Si votre
        score de crédit tombe en dessous de 90 points, vos privilèges de retrait seront
        restreints. Pour restaurer votre score, vous devez soit : Effectuer un nouveau dépôt,
        soit Passer au niveau VIP supérieur. (Note : Cela assure la sécurité du compte et
        prévient les activités frauduleuses.)`,
  common_txt34: `Développement illimité de subordonnés`,
  common_txt35: `Description de l'événement`,
  common_txt36: `<p class="m-b-10">
          Heure de règlement : Le système réglera la commission de la veille
          à 00:00 du lendemain.
        </p>
        <p class="m-b-10">
          Invitez vos amis à rejoindre le jeu de différentes manières : via notre
          site web Facebook /Instagram/TikTok /Telegram /WhatsApp /YouTube, etc.
          Hâtez-vous d'inviter tous les membres qui se sont inscrits via votre lien
          unique pour devenir vos agents directs, mais veuillez noter que les nouveaux
          membres que vous invitez doivent être réels et valides.
        </p>
        <p class="m-b-10">Principaux avantages :</p>
        <p class="m-b-10">
          1. Obtenez des bonus d'invitation et des commissions élevées Si votre premier
          dépôt est réussi, vous pouvez obtenir un bonus de 3 000. Par exemple, si vous
          invitez 10 personnes à effectuer leur premier dépôt, vous pouvez gagner 30 000.
          Plus vous invitez de personnes, plus vous obtenez de bonus. Vous pouvez consulter
          votre historique sur la page de promotion.
        </p>
        <p class="m-b-10">
          2. Si vos clients parient 1 # ou plus, vous pouvez déjà bénéficier de
          commissions élevées ! Vous pouvez gagner jusqu'à 5 % de commission à vie,
          ce qui est une invitation à vie ! Par exemple : Vous avez 100 membres en
          ligne, et le total des paris effectifs quotidiens est estimé à 300 millions.
          La commission que vous recevez chaque jour est : 300 000x2%=6 000. C'est
          super facile de gagner des commissions chaque mois.
        </p>`,
  common_txt37: `Roulette`,
  common_txt38: `Partager`,
  common_txt39: `Trésor`,
  common_txt40: `Enveloppe rouge`,
  common_txt41: `Secours`,
  common_txt42: `Historique des jeux`,
  common_txt43: `Inscription`,
  common_txt44: `Détails du portefeuille`,
  common_txt45: `Score de crédit`,
  common_txt46: `Nom réel`,
  common_txt47: `Numéro de carte`,
  common_txt48: `Niveau`,
  common_txt49: `Paris d'équipe`,
  common_txt50: `Ratio`,
  common_txt51: `Gain`,
  common_txt52: `Règles`,
  common_txt53: `Gagner ≥`,
  common_txt54: `pour réclamer.`,
  common_txt55: `Solde :`,
  common_txt56: `copier`,
  common_txt57: `Mon lien :`,
  common_txt58: `Partage rapide`,
  common_txt59: `Méthode de paiement :`,
  common_txt60: `TOUS`,
  common_txt61: `plus`,
  common_txt62: `Lobby`,
  common_txt63: `Catégorie de jeux`,
  common_txt64: `installer`,
  common_txt65: `Numéro incorrect`,
  common_txt66: `Score de crédit`,
  common_txt67: `Chargement`,
  common_txt68: `afin de pouvoir retirer`,
  common_txt69: `Résultat du loto :`,
  common_txt70: `Gameplay`,
  common_txt71: `Choix rapide`,
  common_txt72: `Au total`,
  common_txt73: `paris`,
  common_txt74: `Prix`,
  common_txt75: `Un pari unique peut gagner`,
  common_txt76: `pari`,
  common_txt77: `Commande de loterie`,
  common_txt78: `Vide`,
  common_txt79: `Type de pari`,
  common_txt80: `Instructions`,
  common_txt81: `Paris d'aujourd'hui`,
  common_txt82: `Résultats`,
  common_txt83: `Sélectionnez au moins `,
  common_txt84: ` numéros.`,
  common_txt85: `Gain maximum par boules`,
  common_txt86: `Montant`,
  common_txt87: `Argent :`,
  common_txt88: `Lignes`,
  common_txt89: `Sélectionné :`,
  common_txt90: `Total :`,
  common_txt91: `Solde :`,
  common_txt92: `Parier`,
  common_txt93: `Vous n'avez pas encore passé de commande.`,
  common_txt94: `Pour participer, vous pouvez marquer entre 2 et 6 trèfles.`,
  common_txt95: `Votre montant de pari dépasse votre solde.`,
  common_txt96: `Veuillez choisir deux numéros chanceux.`,
  common_txt97: `Sélectionnez au moins un numéro dans chaque colonne.`,
  common_txt98: `Choisissez votre mois chanceux. Dans chaque concours, un mois est tiré au sort.`,
  common_txt99: `Janvier`,
  common_txt100: `Février`,
  common_txt101: `Mars`,
  common_txt102: `Avril`,
  common_txt103: `Mai`,
  common_txt104: `Juin`,
  common_txt105: `Juillet`,
  common_txt106: `Août`,
  common_txt107: `Septembre`,
  common_txt108: `Octobre`,
  common_txt109: `Novembre`,
  common_txt110: `Décembre`,
  common_txt111: `Sélectionnez au moins un mois chanceux.`,
  common_txt112: `Veuillez sélectionner vos numéros.`,
  common_txt113: `Le pari minimum est de `,
  common_txt114: `Veuillez sélectionner.`,
  common_txt115: `Montant :`,
  common_txt116: `Détails des paris`,
  common_txt117: `Informations sur le programme`,
  common_txt118: `Montant du pari :`,
  common_txt119: `Heure du pari :`,
  common_txt120: `Numéro de commande :`,
  common_txt121: `Contenu du programme`,
  common_txt122: `Cotes :`,
  common_txt123: `fois`,
  common_txt124: `dose, au total`,
  common_txt125: `doses.`,
  common_txt126: `CONTINUER DE PARER`,
  common_txt127: `RÉVOQUER`,
  common_txt128: `Paris d'aujourd'hui`,
  common_txt129: `Historique des paris`,
  common_txt130: `Oups ! Aucune donnée pour le moment !`,
  common_txt131: `Non réglé`,
  common_txt132: `Réglé`,
  common_txt133: `Bonus`,
  common_txt134: `Pertes`,
  common_txt135: `Derniers résultats`,
  common_txt136: `Derniers résultats :`,
  common_txt137: `Code de machine :`,
  common_txt138: `Loterie`,
  common_txt139: `Casino`,
  common_txt140: `Rejoindre Telegram`,
  common_txt141: `Commissions d'équipe`,
  common_txt142: `Synthèse des données`,
  common_txt143: `Montant de recharge`,
  common_txt144: `Rechercher des jeux`,
  common_txt145: `Aucun jeu`,
  common_txt146: `Rechercher`,
  common_txt147: `Jeu sur TheLotter`,
  common_txt148: `Comment ça marche ?`,
  common_txt149: `Vous jouez`,
  common_txt150: `Sélectionnez la loterie que vous souhaitez jouer et remplissez vos billets avec vos numéros préférés.`,
  common_txt151: `Nous achetons`,
  common_txt152: `Nous achèterons des billets officiels pour votre compte auprès d'un revendeur agréé
et les scannerons dans votre compte privé sûr et sécurisé.`,
  common_txt153: `Vous gagnez`,
  common_txt154: `Nous vous informerons lorsque vous gagnerez
et transférerons vos prix sans commission`,
  common_txt155: `L'argent bonus à collectionner gratuitement n'est pris en charge que pour les jeux électroniques PG.`,
  common_txt156: `Cher joueur,
Notre système a détecté que votre niveau VIP est actuellement bas. Pour la sécurité de vos fonds, vos fonctionnalités de jeu ont été temporairement désactivées. Veuillez d'abord effectuer un retrait réussi, puis recharger pour restaurer toutes les fonctionnalités de jeu.`,
  common_txt157: `Solde insuffisant, veuillez recharger et continuer.`,
  common_txt158: `Veuillez effectuer le premier dépôt.`,
  common_txt159: `Le développeur du jeu effectue une maintenance sur le jeu, veuillez réessayer plus tard.`,
  common_txt160: `La fonctionnalité du jeu a été désactivée. Veuillez contacter le support en ligne pour obtenir de l'aide.`,
  common_txt161: `Êtes-vous sûr de vouloir annuler la commande ?`,
  common_txt162: `Tirage`,
  common_txt163: `Commande`,
  common_txt164: `VUKAVI est un agent de Golden Chance Lotto et une société exerçant l'activité de loterie. Tous les produits de loterie proposés sur la plateforme sont fournis par Golden Chance Lotto et traités par les agents officiels de VUKAVI.`,
  common_txt165: `Partager sur les réseaux sociaux`,
  common_txt166: `Méthodes de paiement acceptées :`,
  common_txt167: `cartes et cryptomonnaies.`,
  common_txt168: `Loteries`,
  common_txt169: `Loteries`,
  common_txt170: `MILLIONS`,
  common_txt171: `Grand prix`,
  common_txt172: `Ils ont gagné le grand prix`,
  common_txt173: `Prix distribués`,
  common_txt174: `compte`,
  common_txt175: `loterie`,
  common_txt176: `prix`,
  common_txt177: `Vérifiez les derniers résultats de la loterie`,
  common_txt178: `Acheter`,
  common_txt179: `Tirage tenu à ESPAÇO DA SORTE à SÃO`,
  common_txt180: `PAULO, SP`,
  common_txt181: `valider`,
  common_txt182: `1er tirage`,
  common_txt183: `2ème tirage`,
  common_txt184: `Vérifiez le résultat de la Quina`,
  common_txt185: `VUKAVI est un agent de Golden Chance Lotto et une société exerçant l'activité de
          loterie. Tous les produits de loterie proposés sur la plateforme sont
          fournis par Golden Chance Lotto et traités par les agents officiels de VUKAVI.`,
  common_txt186: `Partager sur les réseaux sociaux`,
  common_txt187: `Méthodes de paiement acceptées :`,
  common_txt188: `Cartes de crédit, PIX et PicPay.`,
  common_txt189: `Tous`,
  common_txt190: `numéro`,
  common_txt191: `devise`,
  common_txt192: `Jour`,
  common_txt193: `Historique des paris`,
  common_txt194: `Tiré au sort`,
  common_txt195: `Pas encore tiré au sort`,
  common_txt196: `Heure du pari`,
  common_txt197: `montant`,
  common_txt198: `Prix total`,
  common_txt199: `Non gagnant`,
  common_txt200: `Prix annulé`,
  common_txt201: `Gagné`,
  common_txt202: `Annulation par le système`,
  common_txt203: `À tirer au sort`,
  common_txt204: `gagner`,
  common_txt205: `fois,`,
  common_txt206: `paris, pour un total de`,
  common_txt207: `Pariez maintenant`,
  common_txt208: `Fermeture des paris`,
  common_txt209: `édition de la loterie`,
  common_txt210: `l'édition précédente :`,
  common_txt211: `ème rangée`,
  common_txt212: `Actuellement, le système ne prend pas en charge les paris sur différentes
          loteries dans un seul pari. Si vous continuez, votre panier sera vidé !`,
  common_txt213: `continuer`,
  common_txt214: `Les paris pour la ronde actuelle de la loterie sont fermés et la nouvelle ronde est maintenant ouverte.`,
  common_txt215: `J'ai plus de 18 ans et j'ai lu et accepté les Conditions d'utilisation et la Politique de confidentialité.`,
  common_txt216: `Oui, je veux recevoir des offres et des réductions exclusives !`,
  common_txt217: `N° du tirage`,
  common_txt218: `Montant`,
  common_txt219: `Statut`,
  common_txt220: `Prix`,
  common_txt221: `1. Il n'y a pas de limite au nombre de retraits par jour, et VUKAVI propose
          un support de retrait en ligne 24h/24 et 7j/7.`,
  common_txt222: `2. Le montant minimum pour un retrait unique est de`,
  common_txt223: `. Aucune demande de retrait ne peut être initiée pour des montants inférieurs à ce seuil.`,
  common_txt224: `3. Chaque utilisateur ne peut initier qu'une seule demande de retrait à la fois. Une nouvelle demande de retrait
          ne peut être effectuée qu'après le traitement de la précédente.`,
  common_txt225: `4. Normalement, votre retrait sera crédité sur votre compte bancaire dans les 1 minute.
          Si vous ne recevez pas le montant du retrait après une longue période, veuillez
          contacter le support client pour obtenir de l'aide.`,
  common_txt226: `Total dépensé :`,
  common_txt227: `Prix total :`,
  common_txt228: `REMBOURSEMENT<br/>POUR PERTE DE JEU`,
  common_txt229: `CASHBACK JUSQU'À 50%`,
  common_txt230: `TOUR GRATUIT`,
  common_txt231: `CONNECTEZ-VOUS POUR <br/>RECEVOIR DES <br/>RÉCOMPENSES SUPPLÉMENTAIRES`,
  common_txt232: `OUVRIR VOTRE<br/>BOÎTE CHANCEUSE`,
  common_txt233: `LE PRIX MAXIMAL<br/>PEUT ATTEINDRE JUSQU'À`,
  common_txt234: `MEMBRE VIP`,
  common_txt235: `PRIX DE MISE À NIVEAU VIP<br/>PRIX VIP MENSUEL<br/>PRIX VIP PLUS ABONDANTS`,
  common_txt236: `PLUIE<br/>DE PAQUETS D'ARGENT<br/>QUOTIDIENNE`,
  common_txt237: ``,
  common_txt238: `BONUS DE DÉPÔT`,
  common_txt239: `PLUS LES<br/>DÉPÔTS SONT ACCUMULÉS,<br/>PLUS LES SURPRISES SONT GRANDES`,
  common_txt240: `PRIX DE PARIS D'ÉQUIPE`,
  common_txt241: `VOTRE ÉQUIPE REÇOIT <br/>UNE RÉCOMPENSE<br/>DE CASHBACK HEBDOMADAIRE`,
  common_txt242: `COMMISSION D'INVITATION`,
  common_txt243: `PLUS VOUS INVITEZ DE PERSONNES,<br/>PLUS LE BONUS EST ÉLEVÉ`,
  common_txt244: `MEMBRE VIP`,
  common_txt245: `L'accès VIP quotidien et la connexion<br/>garantissent des récompenses<br/>généreuses`,
  common_txt246: `Choisissez le réseau auquel vous connecter :`,
  common_txt247: `Recevoir en nairas nigérians `,
  common_txt248: `Compte à rebours de paiement`,
  common_txt249: `Adresse de dépôt`,
  common_txt250: `Copier l'adresse`,
  common_txt251: `Paiement réussi`,
  common_txt252: `Délai de paiement expiré`,
  common_txt253: `1.Veuillez compléter le paiement avant l'expiration du compte à rebours de la commande.`,
  common_txt254: `2.Vous pouvez obtenir l'adresse du portefeuille en scannant le code QR ou en le copiant.`,
  common_txt255: `3.Veuillez sélectionner le bon réseau lors du paiement.`,
  common_txt256: `Historiques`,
  common_txt257: `Le canal de paiement est disponible.`,
  common_txt258: `Modifier`,
  common_txt259: `Solde du compte`,
  common_txt260: `Historiques des retraits`,
  common_txt261: `Historiques des jeux`,
  common_txt262: `Email`,
  common_txt263: `Mes jeux sauvegardés`,
  common_txt264: `Aide & FAQ`,
  common_txt265: `Partenaires commerciaux`,
  common_txt266: `Service client en ligne`,
  common_txt267: `Commencer la connexion sur VUKAVI`,
  common_txt268: `Commencer l'inscription sur VUKAVI`,
  common_txt269: `Créer un compte`,
  common_txt270: `Vous avez déjà un compte ?`,
  common_txt271: `Accepter ou refuser les Conditions d'utilisation et la Politique de confidentialité`,
  common_txt272: `Veuillez sélectionner un pays`,
  common_txt273: `Veuillez vous assurer que le pays sélectionné est correct !`,
  common_txt274: `- SUPPORT JOUEUR -`,
  common_txt275: `(Cliquez sur l'icône ci-dessous pour contacter le service client)`,
  common_txt276: `Support en ligne 24h/24, 7j/7`,
  common_txt277: `Service client en ligne`,
  common_txt278: `Activités exceptionnelles`,
  common_txt279: `Rejoignez notre communauté`,
  common_txt280: `Groupes et chaînes des réseaux sociaux`,
  common_txt281: `Mes jeux sauvegardés`,
  common_txt282: `Aide & FAQ`,
  common_txt283: `Support en direct`,
  common_txt284: `Bon d'achat en argent`,
  common_txt285: `Partenaires commerciaux`,
  common_txt286: `Coordonnées commerciales :`,
  common_txt287: `Rejoignez notre communauté`,
  common_txt288: `Mes jeux sauvegardés `,
  common_txt289: `Aide & FAQ`,
  common_txt290: `Partenaires commerciaux`,
  common_txt291: `Service client en ligne`,
  common_txt292: `Modifier votre mot de passe`,
  common_txt293: `Boîte de réception`,
  common_txt294: `Bienvenue sur VUKAVI`,
  common_txt295: `Contenu :Bienvenue sur <span style='color:#ff8b2d'>VUKAVI</span> !`,
  common_txt296: `Mes jeux sauvegardés`,
  common_txt297: `Problèmes courants`,
  common_txt298: `Comment jouer ?`,
  common_txt299: `
            1. Inscrivez-vous avec votre propre numéro de téléphone.<br>
            2. Effectuez un dépôt pour jouer aux jeux de votre choix.<br>
            3. Après un dépôt réussi, vous pouvez choisir les jeux que vous aimez et parier. Si vous ne savez pas comment jouer ou comment fonctionnent les jeux, vous pouvez d'abord essayer la démo.
          `,
  common_txt300: `Comment effectuer un dépôt ?`,
  common_txt301: `
            Après l'inscription, vous pouvez cliquer sur Dépôt pour accéder à la page de dépôt. Ensuite, vous pouvez choisir le montant que vous souhaitez déposer ou saisir le montant souhaité. Veuillez faire attention au dépôt minimum.
          `,
  common_txt302: `Comment effectuer un retrait ?`,
  common_txt303: `
            Le retrait est simple et rapide. Cliquez sur le bouton Retrait, suivez les étapes et assurez-vous que vos informations de compte de retrait sont correctes.<br>
            -Faites attention aux conseils de retrait situés sous la page de retrait.<br>
            -Les montants de retrait minimum varient selon les pays.<br>
            -Si vous voyez un ×100 sur le retrait, multipliez-le par 100, ce qui signifie que si vous souhaitez retirer 30,00, il suffit de saisir le nombre 300.
          `,
  common_txt304: `Comment obtenir le bonus de promotion ?`,
  common_txt305: `
            Merci de participer à notre programme de promotion. Tout d'abord, sachez qu'inviter des amis à s'inscrire ou partager votre lien de parrainage ne donne pas droit à de bonus. Ensuite, si vous souhaitez gagner un bonus en espèces, vous pouvez inviter ou encourager des personnes à jouer ; dès qu'elles effectuent un dépôt pour jouer, vous recevrez votre bonus. Le montant que vous obtenez dépend du montant qu'elles déposent pour jouer.
          `,
  common_txt306: `Échec du dépôt ou du retrait ?`,
  common_txt307: `
            Échec du dépôt : veuillez conserver le message de transaction de paiement comme preuve, puis contacter notre Support Jeu en ligne ci-dessous.<br>
            Échec et en attente du retrait :<br>
            -En raison d'un problème de réseau ou d'une erreur dans les informations du compte de retrait : votre retrait échouera. Mais ne vous inquiétez pas, vous pouvez vérifier votre réseau et vos informations, puis effectuer un nouveau retrait.<br>
            -Retrait en attente : ce problème est généralement causé par le système de paiement, veuillez attendre quelques minutes.
          `,
  common_txt308: `Sélectionnez le montant ci-dessous`,
  common_txt309: `Remise VIP >>`,
  common_txt310: `Obtenir`,
  common_txt311: `Le montant minimum`,
  common_txt312: `Privilèges de dépôt`,
  common_txt313: `Montant réel reçu :`,
  common_txt314: `Payer`,
  common_txt315: `-- CONTACTER LE SERVICE CLIENT --`,
  common_txt316: `*Si le paiement échoue ou si un problème survient avec la méthode de paiement, veuillez contacter le service client.`,
  common_txt317: `Conseils de dépôt`,
  common_txt318: `Instructions de retrait`,
  common_txt319: `Obtenir gratuitement`,
  common_txt320: `Vous pouvez obtenir des bonus en participant à l'invitation d'amis à s'inscrire et à jouer. Que vous complétiez l'événement ou non, vous recevrez des récompenses en espèces à la fin.`,
  common_txt321: `Compte à rebours`,
  common_txt322: `Détails des invitations`,
  common_txt323: `Code`,
  common_txt324: `Heure`,
  common_txt325: `Nombre d'invités`,
  common_txt326: `--- Aucune autre donnée disponible ! ---`,
  common_txt327: `Règles de l'événement`,
  common_txt328: `Alliance`,
  common_txt329: `Informations du compte`,
  common_txt330: `Nombre total de personnes`,
  common_txt331: `Recharges totales`,
  common_txt332: `Nouvelle recharge`,
  common_txt333: `Nombre de nouvelles recharges`,
  common_txt334: `Voir tous les niveaux de commission`,
  common_txt335: `Niveau de commission`,
  common_txt336: `Bonus mensuel`,
  common_txt337: `Montant de recharge`,
  common_txt338: `Partager avec votre communauté sociale`,
  common_txt339: `Partagez ce lien de parrainage avec vos amis.`,
  common_txt340: `Copier`,
  common_txt341: `Affichage des remises d'agent d'aujourd'hui`,
  common_txt342: `Niveau de remise`,
  common_txt343: `Remise directe`,
  common_txt344: `Remise d'équipe`,
  common_txt345: `Remise directe %`,
  common_txt346: `Bénéfice net direct`,
  common_txt347: `Remise directe`,
  common_txt348: `Remise d'équipe %`,
  common_txt349: `Bénéfice net d'équipe`,
  common_txt350: `Remise d'équipe`,
  common_txt351: `Note :<br />
              Le montant de la remise (1000) peut être réclamé après 00h30.
              <p style="color: #8c8c8c">
                1.A : Les utilisateurs directs sont les joueurs que vous avez invités.
              </p>
              <p style="color: #8c8c8c">
                2.B : Les utilisateurs d'équipe sont les joueurs invités par vos utilisateurs directs.
              </p>`,
  common_txt352: `Remise directe %`,
  common_txt353: `Remise d'équipe %`,
  common_txt354: `Montant de la remise`,
  common_txt355: `Montant réclamable`,
  common_txt356: `Obtenir de l'argent`,
  common_txt357: 'Petit message doux: Bonjour, cher(e) joueur(euse)! Si vous rencontrez le moindre petit problème avec vos dépôts ou retraits, contactez notre service client en ligne immédiatement! Nous sommes là pour vous aider avec beaucoup de tendresse, d\'attention et de rapidité — tout cela pour que votre expérience soit légère, joyeuse et sans stress!\nSUPER PROMOTION IMPARABLE!\nParticipez à la super promotion de la boîte à prix! Invitez 1 ami et recevez 50. Gagnez jusqu\'à 500 000 facilement!\nRecevez une commission exclusive de 5% en invitant des amis! Gagnez jusqu\'à 1 000 000 par mois simplement et en toute sécurité!\nDes surprises incroyables!\nInscrivez-vous sur VUKAVI maintenant et profitez de bonus inoubliables!\nFaites votre pointage quotidien: de manière consécutive et recevez 888 Bonus jusqu\'à 9 999! Jusqu\'à 12 fois par jour!\nHoraires de distribution: 23:00 - 23:59 · 00:00 - 00:59 · 01:00 - 01:59 · 02:00 - 02:59 · 03:00 - 03:59 · 04:00 - 04:59 · 05:00 - 05:59 · 06:00 - 06:59 · 07:00 - 07:59 · 08:00 - 08:59 · 10:00 - 10:59 · 11:00 - 11:59\nPlateforme fiable, dépôts et retraits rapides!\nRejoignez VUKAVI maintenant et commencez votre voyage vers la richesse!\nVUKAVI - Le plus grand et le plus fiable casino en ligne!\nProbabilité de gain élevée sur les jeux PG, promotions continues et richesse à portée de main!\nLes meilleurs machines à sous, du plaisir sans fin et de l\'excitation garantie!\nÉquité et transparence, licence officielle et fiabilité garantie!\nSûr et stable, pas de soucis avec les dépôts et retraits!\nInscrivez-vous maintenant et commencez votre voyage pour gagner de l\'argent!',
  common_txt358: `Rejoignez notre communauté`,
  common_txt359: `Groupes et chaînes des réseaux sociaux`,
  common_txt360: `COOPÉRATIF`,
  common_txt361: `Ce jeu est réservé aux personnes âgées de plus de 18 ans. Le jeu peut avoir des effets néfastes s'il n'est pas pratiqué avec modération.`,
  common_txt362: `Vous ne pouvez utiliser que votre numéro enregistré pour créditer votre portefeuille ; s'il est incorrect, veuillez vous réenregistrer avec votre bon numéro de Mobile Money.`,
  common_txt363: `Confirmation de paiement`,
  common_txt364: `Veuillez saisir le code de vérification à 6 chiffres.`,
  common_txt365: `1.Pour générer un code temporaire, ouvrez l'application Orange Money Africa et
            cliquez sur « Générer un OTP », ou composez le numéro `,
  common_txt366: `Note importante : Vérifiez que le montant affiché sur l'OTP que vous recevez est de `,
  common_txt367: `, sinon le paiement ne sera pas effectué.`,
  common_txt368: ` (cliquez pour composer) et
            écoutez l'appel.<br />
            2.Saisissez ici le code de vérification généré.<br />
            3.Veuillez saisir le code de vérification reçu par SMS.<br />`,
  common_txt369: `Le numéro de compte doit être composé exclusivement de 8 à 13 chiffres.`,
  common_txt370: `Pour effectuer le paiement avec `,
  common_txt371: `<span class="info-color">Étape 1 : </span> Confirmez que vous souhaitez continuer, puis saisissez votre code PIN de paiement pour autoriser la transaction.`,
  common_txt372: `<span class="info-color">Étape 2 : </span> Attendez que le paiement soit terminé.`,
  common_txt373: `Fermez cette fenêtre et réessayez si le système le rejette en raison d'une erreur réseau.`,
  common_txt374: ` , suivez ces étapes :`,
  common_txt375: `Ne peut pas être inférieur à 6 caractères`,
  common_txt376: `Le numéro doit comporter 8 à 11 chiffres et ne peut pas commencer par 0.`,
  tab_menu: 'Menu',
  tab_promotions: 'Promotions',
  activity_tab: 'Activités',
  activity_new: 'Nouveau',
  activity_events: 'Événements',
  activity_season_pass: 'Pass Saisonnier',
  activity_season_pass_desc: 'Débloquez des niveaux premium exclusifs',
  activity_limited_offers: 'Offres Limitées',
  activity_more_events: 'Plus d\'événements',
  activity_active: 'Actif',
  activity_welcome_bonus: 'Bonus de Bienvenue',
  activity_welcome_bonus_desc: '100% Correspondance jusqu\'à $200',
  activity_first_deposit_chest: 'Coffre du Premier Dépôt',
  activity_first_deposit_chest_desc: 'Déverrouillage instantané',
  activity_super_value: 'Packs Super Valeur',
  activity_super_value_desc: '50% valeur supplémentaire',
  activity_lucky_spin: 'Tour de Chance',
  activity_lucky_spin_desc: 'Tour gratuit toutes les 12 heures',
  activity_weekly_missions: 'Missions Hebdomadaires',
  activity_weekly_missions_desc: 'Complétez les missions pour les récompenses',
  activity_red_envelope: 'Pluie d\'Enveloppes',
  activity_red_envelope_desc: 'Gagnez des prix en espèces',
  activity_spin: 'Tourner',
  activity_view: 'Voir',
  activity_join: 'Rejoindre',
  activity_vip: 'VIP',
  activity_daily_checkin: 'Connexion quotidienne',
  activity_daily_checkin_desc: 'Vous pouvez obtenir des récompenses de connexion en vous connectant au jeu chaque jour, et vous pouvez en obtenir plus après un dépôt.',
  activity_checkin_title: 'Connexion',
  activity_register_checkin: 'Connexion d\'inscription',
  activity_deposit_checkin: 'Connexion de dépôt',
  activity_premium_tip: 'Les récompenses premium sont débloquées après un paiement quotidien',
  activity_deposit_required: 'Veuillez d\'abord effectuer un dépôt pour débloquer les récompenses premium',
  activity_checkin_success: 'Connexion réussie !',
  activity_already_checked: 'Déjà connecté aujourd\'hui',
  activity_coming_soon: 'Bientôt disponible',
  activity_stay_tuned: 'Restez à l\'écoute, quelque chose d\'incroyable arrive!',
  activity_invite_earn: 'Inviter et gagner',
  activity_invite_earn_desc: 'Invitez des amis à effectuer des tâches d\'inscription et de dépôt pour gagner des récompenses en espèces. Répétable !',
  activity_cash_rain: 'Pluie d\'argent',
  activity_cash_rain_desc: 'Les joueurs déposants cliquent chaque jour pour gagner des prix en espèces.',
  activity_details: 'Détails',
  activity_invite_now: 'Inviter maintenant',
  activity_day: 'Jour',
  activity_checkin_btn: 'Se connecter',
  activity_rules: 'Règles',
  activity_rule1: '1. Connectez-vous chaque jour pour recevoir des récompenses, la connexion se réinitialise chaque semaine.',
  activity_rule2: '2. Les utilisateurs inscrits peuvent réclamer des récompenses de base.',
  activity_rule3: '3. Les utilisateurs déposants débloquent des récompenses premium avec des montants plus élevés.',
  activity_rule4: '4. Les jours manqués ne peuvent pas être signés rétroactivement.',
  reward_history: 'Historique des récompenses',
  reward_regular_signin: 'Connexion régulière',
  reward_deposit_signin: 'Connexion avec dépôt',
  reward_premium: 'PREMIUM',
  reward_select_date: 'Sélectionner la date',
  reward_confirm: 'Confirmer la sélection',
  reward_cancel: 'Annuler',
  reward_go_deposit: 'Aller au dépôt',
  reward_your_rewards: 'Vos récompenses',
  reward_claimed: 'RÉCLAMÉ',
  reward_locked: 'VERROUILLÉ',
  reward_claim_coins: 'RÉCLAMER',
  season_pass_title: 'Passe Saison',
  season_current_progress: 'Progression Actuelle',
  season_next_reward: 'Prochaine Récompense',
  season_upgrade_pass: 'AMÉLIORER LE PASSE',
  season_unlock_premium: 'Débloquer les Niveaux Premium',
  season_junior: 'Junior',
  season_senior: 'Senior',
  season_junior_desc: 'Récompenses argent & bonus XP standard',
  season_senior_desc: 'Objets en or & multiplicateurs XP max',
  season_unlock_junior: 'Débloquer Junior',
  season_go_senior: 'Passer Senior Pro',
  season_reward_track: 'Parcours de Récompenses',
  season_points: 'Points',
  season_basic: 'Basique',
  season_claimed: 'RÉCLAMÉ',
  season_claim: 'Réclamer',
  season_locked: 'VERROUILLÉ',
  season_history_title: 'Historique des Saisons',
  season_history_current: 'EN COURS',
  season_history_target: 'Objectif',
  season_history_view_current: 'Voir la Saison en Cours',
  season_history_past: 'Saisons Passées',
  season_history_completed: 'TERMINÉ',
  season_history_expired: 'EXPIRÉ',
  season_history_empty: 'Aucune saison passée',
  lr_target_reward: 'Récompense Cible',
  lr_current_earnings: 'Gains Actuels',
  lr_spins_hint: 'Réclamez toutes les récompenses une fois la barre de progression remplie.',
  lr_claim_reward: 'Réclamer la Récompense',
  lr_spinning: 'EN ROTATION...',
  lr_referral_link: 'Votre Lien de Parrainage',
  lr_copy: 'Copier',
  lr_rules_highlight: 'Obtenez 3 tours GRATUITS!',
  lr_rules_desc: 'Invitez des amis à s\'inscrire (Email/Téléphone vérifié) pour gagner plus de tours. Atteignez l\'objectif pour réclamer votre argent!',
  lr_recent_winners: 'Gagnants Récents',
  lr_player_name: 'Nom du Joueur',
  lr_reward_amount: 'Montant de la Récompense',
  lr_insufficient_spins: 'Tours Insuffisants',
  lr_invite_more: 'Invitez des amis à s\'inscrire et gagnez plus de tours immédiatement!',
  lr_close: 'Fermer',
  ng_title: 'Cadeau Exclusif Nouveau Joueur',
  ng_limited_time: 'Temps Restant Limité',
  ng_limited_price: 'Prix Limité',
  ng_buy_now: 'Acheter Maintenant',
  ng_claim: 'Réclamer',
  ng_claimed: 'Réclamé',
  ng_disclaimer: 'Limité à un achat par utilisateur. Termes et conditions s\'appliquent.',
  ng_total_reward: 'Récompense Totale 3 Jours',
  ng_day1_title: 'Récompense Jour 1',
  ng_day1_desc: 'Obtenez <span class="highlight">100% Bonus de Dépôt</span> + Pack Jour 1 + <span class="highlight">100 Pièces Extra</span>',
  ng_day2_title: 'Récompense Jour 2',
  ng_day2_desc: 'Revenez demain pour <span class="highlight">200 Pièces Extra</span>',
  ng_day3_title: 'Grande Récompense Finale',
  ng_day3_desc: 'Débloquez le prix mystère: <span class="highlight">500 Pièces Extra</span>',
  fd_title: 'Cadeau Premier Dépôt',
  fd_title_short: 'Premier Dépôt',
  fd_gift: 'Cadeau',
  fd_exclusive_offer: 'Offre Exclusive',
  fd_total_value: 'Valeur Totale',
  fd_premium_bundle: 'Pack de Récompenses Premium',
  fd_energy_expires: 'L\'offre expire quand l\'énergie est épuisée',
  fd_limit: 'LIMITE:',
  fd_value: 'Valeur',
  fd_quick_deposit: 'Dépôt Rapide',
  fd_return_300: 'Valeur Totale 300% de Retour!',
  fd_limited_one: 'Limité à un achat par utilisateur.',
  fd_mission_briefing: 'Briefing de Mission',
  fd_total_reward_value: 'Valeur Totale de la Récompense',
  fd_critical_deadline: 'Délai Critique',
  fd_energy_critical: 'Niveau d\'Énergie: Statut Critique',
  fd_claim_now: 'Réclamer Maintenant',
  fd_offer_ends_energy: 'L\'offre se termine quand l\'énergie est épuisée',
  tb_treasure_box: 'Coffre',
  tb_box: 'au Trésor',
  fr_title_short: 'Premier Dépôt',
  fr_bonus: 'Bonus',
  fr_recharge_now: 'Ose le saut → Dépose maintenant',
  fr_up_to_prefix: 'Recevez jusqu\'à',
  fr_up_to_suffix: 'de récompenses.',
  fr_limited_offer: 'Offre Limitée',
  fr_next_unlock: 'Prochain Déblocage',
  fr_day: 'Jour',
  fr_claimed: 'Réclamé',
  fr_locked: 'Verrouillé',
  fr_daily_hint: 'Revenez chaque jour pour réclamer votre récompense.',
  mc_title: 'Centre de Missions',
  mc_daily: 'Quotidien',
  mc_newbie: 'Débutant',
  mc_weekly: 'Hebdomadaire',
  mc_activity_points: 'Points d\'Activité',
  mc_reset_in: 'Réinitialisation dans',
  mc_todays_missions: 'Missions du Jour',
  mc_newbie_missions: 'Missions Débutant',
  mc_weekly_missions: 'Missions Hebdomadaires',
  mc_claim: 'Réclamer',
  mc_claimed: 'Réclamé',
  mc_go: 'Aller',
  mc_pts: 'Pts',
  mc_claim_failed: 'Échec de la réclamation',
  mc_claim_unavailable: 'La récompense est temporairement indisponible. Veuillez réessayer plus tard.',
  mc_locked_title: 'Verrouillé',
  mc_locked_desc: 'Terminez d\'abord toutes les missions Débutant pour débloquer cette section.',
  mc_go_newbie: 'Faire les missions Débutant',
  mc_request_failed: 'Échec du chargement des missions. Veuillez réessayer plus tard.',
  mc_rules_title: 'Règles d\'Activité',
  mc_rule_1: 'Les joueurs recevront une liste de missions quotidiennes simples à la connexion.',
  mc_rule_2: 'Complétez une mission pour recevoir la récompense quotidienne et accumuler des points.',
  mc_rule_3: 'Atteignez des jalons spécifiques pour débloquer des récompenses supplémentaires.',
  mc_rule_4: 'Complétez toutes les missions pour réclamer le grand prix final.',
  profile_account_name: 'Nom du compte',
  profile_real_name: 'Authentification par nom réel',
  profile_login_pass: 'Modifier le mot de passe de connexion',
  profile_withdraw_pass: 'Mot de passe de retrait',
  profile_bank_card: 'Carte bancaire',
  profile_avatar: 'Avatar',
  profile_privacy: 'Politique de confidentialité',

  // ====== Settings Page ======
  settings_title: 'Paramètres',
  settings_account_security: 'SÉCURITÉ DU COMPTE',
  settings_email: 'Adresse e-mail',
  settings_not_set: 'Non défini',
  settings_bind: 'LIER',
  settings_unbind: 'DÉLIER',
  settings_social_binding: 'LIENS SOCIAUX',
  settings_preferences: 'PRÉFÉRENCES',
  settings_language: 'Langue',
  settings_push: 'Notifications push',
  settings_sound: 'Volume sonore',
  settings_bind_phone: 'Lier le téléphone',
  settings_not_bound: 'Non lié',

  // ====== Edit Profile Page ======
  editProfile_title: 'MODIFIER LE PROFIL',
  editProfile_save: 'SAUVER',
  editProfile_user_id: 'ID utilisateur',
  editProfile_nickname: 'Surnom',
  editProfile_nickname_ph: 'Entrer le surnom',
  editProfile_birthday: 'Date de naissance',

  // ====== Password Success Page ======
  pwdSuccess_header: 'MOT DE PASSE MIS À JOUR',
  pwdSuccess_title: 'Mis à jour avec succès !',
  pwdSuccess_desc: 'Votre mot de passe a été modifié. Veuillez utiliser vos nouvelles informations pour les connexions futures.',
  pwdSuccess_done: 'TERMINÉ',
  pwdSuccess_footer: 'Gestion sécurisée du compte',
  pwdConfirm_ph: 'Confirmer le nouveau mot de passe',
  pwdConfirm_mismatch: 'Les mots de passe ne correspondent pas',

  // ====== Transaction Records Page ======
  txRecords_title: 'Historique des transactions',

  // ====== Phone Unbound Page ======
  phoneUnbound_title: 'SÉCURITÉ TÉLÉPHONE',
  phoneUnbound_status: 'AUCUN NUMÉRO DE TÉLÉPHONE LIÉ',
  phoneUnbound_desc: 'Liez votre numéro de téléphone pour renforcer la sécurité du compte, activer les alertes SMS et récupérer facilement votre compte.',
  phoneUnbound_bind: 'LIER LE TÉLÉPHONE',
  phoneUnbound_level: 'Niveau de sécurité :',

  // ====== Mine Page ======
  mine_main: 'Principal',
  mine_bonus: 'Bonus',
  mine_cashback: 'Cashback',
  mine_community: 'Communauté',
  // ====== VIP ======
  vip_title: 'Niveaux VIP',
  vip_level_progress: 'Progression du Niveau',
  vip_tier_advancement: 'Avancement de Palier',
  vip_xp_remaining: 'XP restants pour atteindre le Niveau',
  vip_exclusive_privileges: 'Privilèges Exclusifs',
  vip_level_up_reward: 'Récompense de Montée',
  vip_daily_reward: 'Récompense Quotidienne',
  vip_birthday_gift: "Cadeau d'Anniversaire",
  vip_withdrawal_fee: 'Frais de retrait supprimés',
  vip_daily_withdrawal: 'Retrait Quotidien',
  vip_withdrawal_limit: 'Limite de Retrait',
  vip_loss_rebate: 'Remise sur Perte',
  vip_locked: 'Verrouillé',
  vip_my_gifts: 'Mes Cadeaux',
  vip_not_reached: 'Non atteint',
  vip_claimable: 'Disponible',
  vip_claimed: 'Réclamé',

  // ====== Google Login ======
  google_login: 'Se connecter avec Google',
  google_register_title: "Finaliser l'Inscription",
  google_register_phone: 'Entrez le numéro de téléphone',
  google_login_url_failed: "Impossible d'obtenir l'URL de connexion Google",
  google_login_failed: 'Échec de la connexion Google',
  google_register_failed: "Échec de l'inscription",
  network_error: 'Erreur réseau',
  common_loading: 'Chargement...',
  login_captcha_placeholder: 'Entrez le code de vérification',
  login_captcha_send: 'Envoyer',
  // ====== Google Phone Binding ======
  gpb_title: 'Lier le Téléphone',
  gpb_desc: 'Veuillez lier votre numéro de téléphone pour finaliser votre inscription et sécuriser votre compte',
  gpb_phone_placeholder: 'Entrez le numéro de téléphone',
  gpb_confirm: 'Confirmer la Liaison',
  gpb_confirm_title: 'Avis',
  gpb_confirm_msg: 'Ne pas lier de numéro de téléphone vous déconnectera. Êtes-vous sûr?',
  gpb_confirm_yes: 'Oui',
  gpb_confirm_no: 'Non',
  rp_title: 'Pluie de Paquets Rouges',
  rp_not_qualified: 'Effectuez un dépôt pour débloquer',
  rp_not_open: 'Activité non encore ouverte',
  rp_not_open_desc: 'Veuillez revenir plus tard',
  rp_not_qualified_desc: 'Effectuez un dépôt dans les 3 derniers jours pour participer',
  rp_countdown: 'Prochain Tour Dans',
  rp_round_active: 'Appuyez pour attraper!',
  rp_claimed: 'Déjà réclamé ce tour',
  rp_round_ended: 'Tour Terminé',
  rp_next_round: 'Prochain Tour',
  rp_remaining: 'Restant',
  rp_clicks: 'Clics',
  rp_total_award: 'Récompense Totale',
  rp_your_reward: 'Votre Récompense',
  rp_go_deposit: 'Déposer',
  rp_history: 'Historique',
  rp_rules_title: 'Comment Jouer',
  rp_rule_1: 'Déposez dans les 3 derniers jours pour être éligible',
  rp_rule_2: 'Appuyez sur les paquets rouges pour gagner',
  rp_rule_3: 'Chaque tour a un nombre limité de clics',
  rp_no_history: 'Aucun enregistrement',
  rp_packets_left: 'Paquets Restants',
  rp_round_time: 'Heure du Tour',
  rp_grab_success: 'Félicitations!',
  // ====== Additional i18n Keys ======
  checkin_premium_desc: 'Les récompenses premium sont débloquées après un dépôt quotidien. Accumulez 10 dépôts pour un Méga Spin !',
  checkin_coins: 'Pièces',
  checkin_deposit_for: 'DÉPOSER POUR',
  checkin_missed: 'MANQUÉ',
  lr_title: 'PARRAINAGE CHANCEUX',
  lr_spin_x: 'TOURNER',
  lr_live_feed: 'En Direct',
  ng_best_value: 'MEILLEURE OFFRE',
  ng_active: 'Actif',
  ng_total_value: 'VALEUR TOTALE',
  menu_region: 'Région',
  reward_no_data: 'Aucune récompense trouvée',
  rp_hour: 'H',
  rp_min: 'M',
  rp_sec: 'S',
  rc_first_deposit_bonus: 'Bonus premier dépôt',
  vip_level_text: 'Niveau',
  vip_recharge_progress: 'PROGRESSION RECHARGE',
  vip_bet_progress: 'PROGRESSION MISE',
  vip_next_level: 'NIVEAU SUIVANT',
  /* === VUKAVI i18n 补全 2026-06-10 续(notice_title 原缺;其余 9 key 原已存在,勿重复) === */
  notice_title: 'Avis'
}
